/* eslint-disable */ 
 /* 🤖 This is an generated file, do not alter it directly! 👮 */
import * as Types from './operation-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const EntryId_Swnz_EntryFragmentDoc = /*#__PURE__*/ gql`
    fragment entryId_SWNZ_Entry on SWNZ_Entry {
  sys {
    id
  }
}
    `;
export const ParentPagePath_Swnz_PageFragmentDoc = /*#__PURE__*/ gql`
    fragment parentPagePath_SWNZ_Page on SWNZ_Page {
  ...entryId_SWNZ_Entry
  title
  slug
  parentPage {
    ...entryId_SWNZ_Entry
    title
    slug
    parentPage {
      ...entryId_SWNZ_Entry
      title
      slug
      parentPage {
        ...entryId_SWNZ_Entry
        title
        slug
        parentPage {
          ...entryId_SWNZ_Entry
          title
          slug
          parentPage {
            ...entryId_SWNZ_Entry
            title
            slug
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc = /*#__PURE__*/ gql`
    fragment parentNaumaiPagePath_SWNZ_NaumaiPageStandard on SWNZ_NaumaiPageStandard {
  ...entryId_SWNZ_Entry
  title
  slug
  parentPage {
    ...entryId_SWNZ_Entry
    title
    slug
    parentPage {
      ...entryId_SWNZ_Entry
      title
      slug
      parentPage {
        ...entryId_SWNZ_Entry
        title
        slug
        parentPage {
          ...entryId_SWNZ_Entry
          title
          slug
          parentPage {
            ...entryId_SWNZ_Entry
            title
            slug
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const Glossary_Swnz_GlossaryFragmentDoc = /*#__PURE__*/ gql`
    fragment glossary_SWNZ_Glossary on SWNZ_Glossary {
  ...entryId_SWNZ_Entry
  glossaryTerm
  glossaryDefinition
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const AccordionItem_Swnz_AccordionItemFragmentDoc = /*#__PURE__*/ gql`
    fragment accordionItem_SWNZ_AccordionItem on SWNZ_AccordionItem {
  ...entryId_SWNZ_Entry
  title
  bodyText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
          ... on SWNZ_Glossary {
            ...glossary_SWNZ_Glossary
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}`;
export const Accordion_Swnz_AccordionContainerFragmentDoc = /*#__PURE__*/ gql`
    fragment accordion_SWNZ_AccordionContainer on SWNZ_AccordionContainer {
  ...entryId_SWNZ_Entry
  codeId
  title
  introText
  enableFaqStructuredData
  accordionItemsCollection(limit: 12) {
    items {
      ...accordionItem_SWNZ_AccordionItem
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${AccordionItem_Swnz_AccordionItemFragmentDoc}`;
export const BodyText_Swnz_AlternatingContentBodyTextFragmentDoc = /*#__PURE__*/ gql`
    fragment bodyText_SWNZ_AlternatingContentBodyText on SWNZ_AlternatingContentBodyText {
  json
  links {
    entries {
      hyperlink {
        ...entryId_SWNZ_Entry
        ... on SWNZ_Page {
          ...parentPagePath_SWNZ_Page
        }
        ... on SWNZ_Glossary {
          ...glossary_SWNZ_Glossary
        }
      }
      inline {
        ...entryId_SWNZ_Entry
        ... on SWNZ_Page {
          ...parentPagePath_SWNZ_Page
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}`;
export const Asset_Swnz_AssetFragmentDoc = /*#__PURE__*/ gql`
    fragment asset_SWNZ_Asset on SWNZ_Asset {
  sys {
    id
  }
  title
  description
  fileName
  url
  width
  height
}
    `;
export const MediaImage_Swnz_MediaImageFragmentDoc = /*#__PURE__*/ gql`
    fragment mediaImage_SWNZ_MediaImage on SWNZ_MediaImage {
  ...entryId_SWNZ_Entry
  caption
  isZoomable
  source {
    ...asset_SWNZ_Asset
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Asset_Swnz_AssetFragmentDoc}`;
export const MediaVideo_Swnz_MediaVideoFragmentDoc = /*#__PURE__*/ gql`
    fragment mediaVideo_SWNZ_MediaVideo on SWNZ_MediaVideo {
  ...entryId_SWNZ_Entry
  caption
  sourceUrl
  thumbnail {
    ...asset_SWNZ_Asset
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Asset_Swnz_AssetFragmentDoc}`;
export const Cta_Swnz_CallToActionFragmentDoc = /*#__PURE__*/ gql`
    fragment cta_SWNZ_CallToAction on SWNZ_CallToAction {
  ...entryId_SWNZ_Entry
  label
  href: urlLink
  openInNewWindow
  modalId
  internalLink {
    ...entryId_SWNZ_Entry
    ... on SWNZ_Page {
      slug
      title
      parentPage {
        ...entryId_SWNZ_Entry
        ... on SWNZ_Page {
          ...parentPagePath_SWNZ_Page
        }
      }
    }
    ... on SWNZ_NaumaiPageStandard {
      slug
      title
      parentPage {
        ...entryId_SWNZ_Entry
        ... on SWNZ_NaumaiPageStandard {
          ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}`;
export const AlternatingContent_Swnz_AlternatingContentFragmentDoc = /*#__PURE__*/ gql`
    fragment alternatingContent_SWNZ_AlternatingContent on SWNZ_AlternatingContent {
  ...entryId_SWNZ_Entry
  identifier
  title
  mediaPlacement
  mediaOrientation
  bodyText {
    ...bodyText_SWNZ_AlternatingContentBodyText
  }
  mediaItem {
    ... on SWNZ_MediaImage {
      ...mediaImage_SWNZ_MediaImage
    }
    ... on SWNZ_MediaVideo {
      ...mediaVideo_SWNZ_MediaVideo
    }
  }
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
  secondaryCta {
    ...cta_SWNZ_CallToAction
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${BodyText_Swnz_AlternatingContentBodyTextFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}
${MediaVideo_Swnz_MediaVideoFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const AlternatingQuote_Swnz_AlternatingQuoteFragmentDoc = /*#__PURE__*/ gql`
    fragment alternatingQuote_SWNZ_AlternatingQuote on SWNZ_AlternatingQuote {
  ...entryId_SWNZ_Entry
  identifier
  quoteText
  credit
  creditSuffix
  quoteTextColour
  mediaPlacement
  mediaOrientation
  mediaItem {
    ... on SWNZ_MediaImage {
      ...mediaImage_SWNZ_MediaImage
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}`;
export const AssetId_Swnz_AssetFragmentDoc = /*#__PURE__*/ gql`
    fragment assetId_SWNZ_Asset on SWNZ_Asset {
  sys {
    id
  }
}
    `;
export const BulletPoint_Swnz_BulletPointFragmentDoc = /*#__PURE__*/ gql`
    fragment bulletPoint_SWNZ_BulletPoint on SWNZ_BulletPoint {
  ...entryId_SWNZ_Entry
  bodyText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
          ... on SWNZ_Glossary {
            ...glossary_SWNZ_Glossary
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
      }
    }
  }
  icon {
    ...entryId_SWNZ_Entry
    source {
      ...assetId_SWNZ_Asset
      url
      title
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}
${AssetId_Swnz_AssetFragmentDoc}`;
export const BulletPoints_Swnz_BulletPointContainerFragmentDoc = /*#__PURE__*/ gql`
    fragment bulletPoints_SWNZ_BulletPointContainer on SWNZ_BulletPointContainer {
  ...entryId_SWNZ_Entry
  codeId
  title
  introText
  bulletPointsCollection(limit: 12) {
    items {
      ...bulletPoint_SWNZ_BulletPoint
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${BulletPoint_Swnz_BulletPointFragmentDoc}`;
export const FormLeadCaptureCitiesCollection_Swnz_FormLeadCaptureCitiesCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment formLeadCaptureCitiesCollection_SWNZ_FormLeadCaptureCitiesCollection on SWNZ_FormLeadCaptureCitiesCollection {
  items {
    ...entryId_SWNZ_Entry
    cityLabel
    identifier
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const Swnz_FormDropdownFragmentDoc = /*#__PURE__*/ gql`
    fragment SWNZ_FormDropdown on SWNZ_FormDropdown {
  ...entryId_SWNZ_Entry
  codeId
  label
  dropdownOptionsCollection(limit: 20) {
    items {
      ... on SWNZ_FormDropdownOption {
        ...entryId_SWNZ_Entry
        label
        value
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const FormLeadCapture_Swnz_FormLeadCaptureFragmentDoc = /*#__PURE__*/ gql`
    fragment formLeadCapture_Swnz_FormLeadCapture on SWNZ_FormLeadCapture {
  ...entryId_SWNZ_Entry
  citiesCollection {
    ...formLeadCaptureCitiesCollection_SWNZ_FormLeadCaptureCitiesCollection
  }
  questionHowDidYouHearAboutTheFair {
    ...SWNZ_FormDropdown
  }
  buttonLabel
  displayDateOfBirth
  displayIntendedAreaOfStudy
  displayLineIdField
  displayPersonTypeIAmA
  heading
  identifier
  sourceId
  subHeading
  sys {
    id
  }
  theme
}
    ${EntryId_Swnz_EntryFragmentDoc}
${FormLeadCaptureCitiesCollection_Swnz_FormLeadCaptureCitiesCollectionFragmentDoc}
${Swnz_FormDropdownFragmentDoc}`;
export const EmotionItem_Swnz_EmotionItemBodyTextFragmentDoc = /*#__PURE__*/ gql`
    fragment emotionItem_SWNZ_EmotionItemBodyText on SWNZ_EmotionItemResponseBodyText {
  json
  links {
    entries {
      hyperlink {
        ...entryId_SWNZ_Entry
        ... on SWNZ_NaumaiPageStandard {
          ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
        }
        ... on SWNZ_Glossary {
          ...glossary_SWNZ_Glossary
        }
      }
      inline {
        ...entryId_SWNZ_Entry
        ... on SWNZ_NaumaiPageStandard {
          ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}`;
export const EmotionItem_Swnz_EmotionItemFragmentDoc = /*#__PURE__*/ gql`
    fragment emotionItem_SWNZ_EmotionItem on SWNZ_EmotionItem {
  ...entryId_SWNZ_Entry
  label
  responsesCollection {
    items {
      ...entryId_SWNZ_Entry
      heading
      bodyText {
        ...emotionItem_SWNZ_EmotionItemBodyText
      }
      callToAction {
        ...cta_SWNZ_CallToAction
      }
    }
  }
  icon {
    ...entryId_SWNZ_Entry
    source {
      ...assetId_SWNZ_Asset
      url
      title
      description
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${EmotionItem_Swnz_EmotionItemBodyTextFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}
${AssetId_Swnz_AssetFragmentDoc}`;
export const Emotion_Swnz_EmotionContainerFragmentDoc = /*#__PURE__*/ gql`
    fragment emotion_SWNZ_EmotionContainer on SWNZ_EmotionContainer {
  ...entryId_SWNZ_Entry
  heading
  introText
  emotionItemsCollection(limit: 6) {
    items {
      ...emotionItem_SWNZ_EmotionItem
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${EmotionItem_Swnz_EmotionItemFragmentDoc}`;
export const EnquiryFormFields_Swnz_FormDropdownCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment enquiryFormFields_SWNZ_FormDropdownCollection on SWNZ_FormDropdownCollection {
  items {
    ...entryId_SWNZ_Entry
    label
    codeId
    dropdownOptionsCollection {
      total
      items {
        ...entryId_SWNZ_Entry
        label
        value
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const GalleryCarouselMediaItem_Swnz_GalleryCarouselMediaItemsItemFragmentDoc = /*#__PURE__*/ gql`
    fragment galleryCarouselMediaItem_SWNZ_GalleryCarouselMediaItemsItem on SWNZ_GalleryCarouselMediaItemsItem {
  ...entryId_SWNZ_Entry
  ... on SWNZ_MediaImage {
    ...mediaImage_SWNZ_MediaImage
  }
  ... on SWNZ_MediaVideo {
    ...mediaVideo_SWNZ_MediaVideo
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}
${MediaVideo_Swnz_MediaVideoFragmentDoc}`;
export const GalleryCarousel_Swnz_GalleryCarouselFragmentDoc = /*#__PURE__*/ gql`
    fragment galleryCarousel_SWNZ_GalleryCarousel on SWNZ_GalleryCarousel {
  ...entryId_SWNZ_Entry
  mediaItemsCollection(limit: 10) {
    items {
      ...galleryCarouselMediaItem_SWNZ_GalleryCarouselMediaItemsItem
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${GalleryCarouselMediaItem_Swnz_GalleryCarouselMediaItemsItemFragmentDoc}`;
export const InfoBox_Swnz_InfoBoxFragmentDoc = /*#__PURE__*/ gql`
    fragment infoBox_SWNZ_InfoBox on SWNZ_InfoBox {
  ...entryId_SWNZ_Entry
  infoText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Glossary {
            ...glossary_SWNZ_Glossary
          }
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}`;
export const Blockquote_Swnz_BlockquoteFragmentDoc = /*#__PURE__*/ gql`
    fragment blockquote_SWNZ_Blockquote on SWNZ_Blockquote {
  ...entryId_SWNZ_Entry
  bodyText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
          ... on SWNZ_Glossary {
            ...glossary_SWNZ_Glossary
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}`;
export const GenericBodyTextLinks_Swnz_GenericTextBodyTextLinksFragmentDoc = /*#__PURE__*/ gql`
    fragment genericBodyTextLinks_SWNZ_GenericTextBodyTextLinks on SWNZ_GenericTextBodyTextLinks {
  entries {
    hyperlink {
      ...entryId_SWNZ_Entry
      ... on SWNZ_Page {
        ...parentPagePath_SWNZ_Page
      }
      ... on SWNZ_NaumaiPageStandard {
        ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
      }
      ... on SWNZ_Glossary {
        ...glossary_SWNZ_Glossary
      }
    }
    block {
      ...entryId_SWNZ_Entry
      ... on SWNZ_Page {
        ...parentPagePath_SWNZ_Page
      }
      ... on SWNZ_NaumaiPageStandard {
        ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
      }
      ... on SWNZ_InfoBox {
        ...infoBox_SWNZ_InfoBox
      }
      ... on SWNZ_MediaImage {
        ...mediaImage_SWNZ_MediaImage
      }
      ... on SWNZ_Blockquote {
        ...blockquote_SWNZ_Blockquote
      }
    }
    inline {
      ...entryId_SWNZ_Entry
      ... on SWNZ_Page {
        ...parentPagePath_SWNZ_Page
      }
      ... on SWNZ_NaumaiPageStandard {
        ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}
${InfoBox_Swnz_InfoBoxFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}
${Blockquote_Swnz_BlockquoteFragmentDoc}`;
export const GenericBodyText_Swnz_GenericTextBodyTextFragmentDoc = /*#__PURE__*/ gql`
    fragment genericBodyText_SWNZ_GenericTextBodyText on SWNZ_GenericTextBodyText {
  json
  links {
    ...genericBodyTextLinks_SWNZ_GenericTextBodyTextLinks
  }
}
    ${GenericBodyTextLinks_Swnz_GenericTextBodyTextLinksFragmentDoc}`;
export const GenericText_Swnz_GenericTextFragmentDoc = /*#__PURE__*/ gql`
    fragment genericText_SWNZ_GenericText on SWNZ_GenericText {
  ...entryId_SWNZ_Entry
  title
  contentAlignment
  backgroundColour
  themeBackgroundPosition
  bodyText {
    ...genericBodyText_SWNZ_GenericTextBodyText
  }
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
  secondaryCta {
    ...cta_SWNZ_CallToAction
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${GenericBodyText_Swnz_GenericTextBodyTextFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const ImpactText_Swnz_ImpactTextFragmentDoc = /*#__PURE__*/ gql`
    fragment impactText_SWNZ_ImpactText on SWNZ_ImpactText {
  ...entryId_SWNZ_Entry
  backgroundColour
  description
  displayAsQuote
  textAlignment
  textColour
  bodyText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_Glossary {
            ...glossary_SWNZ_Glossary
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
      }
    }
  }
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
  secondaryCta {
    ...cta_SWNZ_CallToAction
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const IntroTextWithJumpMenu_Swnz_IntroTextWithJumpMenuFragmentDoc = /*#__PURE__*/ gql`
    fragment introTextWithJumpMenu_SWNZ_IntroTextWithJumpMenu on SWNZ_IntroTextWithJumpMenu {
  ...entryId_SWNZ_Entry
  bodyText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
      }
    }
  }
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const JumpAhead_Swnz_JumpAheadFragmentDoc = /*#__PURE__*/ gql`
    fragment jumpAhead_SWNZ_JumpAhead on SWNZ_JumpAhead {
  ...entryId_SWNZ_Entry
  title
  anchorName
  displayInMenu
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const KeepExploring_Swnz_KeepExploringFragmentDoc = /*#__PURE__*/ gql`
    fragment keepExploring_SWNZ_KeepExploring on SWNZ_KeepExploring {
  ...entryId_SWNZ_Entry
  title
  ctaLinksCollection(limit: 6) {
    items {
      ...cta_SWNZ_CallToAction
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const MapContainer_Swnz_MapContainerFragmentDoc = /*#__PURE__*/ gql`
    fragment mapContainer_SWNZ_MapContainer on SWNZ_MapContainer {
  ...entryId_SWNZ_Entry
  pagesCollection(limit: 20) {
    items {
      ...entryId_SWNZ_Entry
      region
      ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
      sectionsCollection(limit: 1) {
        items {
          ...entryId_SWNZ_Entry
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}`;
export const NextStepsItem_Swnz_NextStepsItemFragmentDoc = /*#__PURE__*/ gql`
    fragment nextStepsItem_SWNZ_NextStepsItem on SWNZ_NextStepsItem {
  ...entryId_SWNZ_Entry
  codeId
  title
  description
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
  secondaryCta {
    ...cta_SWNZ_CallToAction
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const NextSteps_Swnz_NextStepsFragmentDoc = /*#__PURE__*/ gql`
    fragment nextSteps_SWNZ_NextSteps on SWNZ_NextSteps {
  ...entryId_SWNZ_Entry
  title
  codeId
  nextStepsItemsCollection(limit: 4) {
    items {
      ...nextStepsItem_SWNZ_NextStepsItem
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${NextStepsItem_Swnz_NextStepsItemFragmentDoc}`;
export const ProfileFormFields_Swnz_FormDropdownCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment profileFormFields_SWNZ_FormDropdownCollection on SWNZ_FormDropdownCollection {
  items {
    ...entryId_SWNZ_Entry
    label
    codeId
    dropdownOptionsCollection {
      total
      items {
        ...entryId_SWNZ_Entry
        label
        key: value
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const Promo_Swnz_PromoFragmentDoc = /*#__PURE__*/ gql`
    fragment promo_SWNZ_Promo on SWNZ_Promo {
  ...entryId_SWNZ_Entry
  identifier
  title
  image {
    ...entryId_SWNZ_Entry
    caption
    source {
      ...asset_SWNZ_Asset
    }
  }
  primaryCta {
    ...entryId_SWNZ_Entry
    ...cta_SWNZ_CallToAction
  }
  showFilterCta
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Asset_Swnz_AssetFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const CardWithLink_Swnz_CardWithLinkFragmentDoc = /*#__PURE__*/ gql`
    fragment cardWithLink_SWNZ_CardWithLink on SWNZ_CardWithLink {
  ...entryId_SWNZ_Entry
  title
  description
  customUrl
  image {
    ...mediaImage_SWNZ_MediaImage
  }
  link {
    ... on SWNZ_Page {
      title
      ...parentPagePath_SWNZ_Page
    }
    ... on SWNZ_NaumaiPageStandard {
      title
      ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
    }
  }
  contentfulMetadata {
    tags {
      name
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}`;
export const CardWithModal_Swnz_CardWithModalFragmentDoc = /*#__PURE__*/ gql`
    fragment cardWithModal_SWNZ_CardWithModal on SWNZ_CardWithModal {
  ...entryId_SWNZ_Entry
  title
  description
  image {
    ...mediaImage_SWNZ_MediaImage
  }
  modalContent {
    ...entryId_SWNZ_Entry
    __typename
  }
  contentfulMetadata {
    tags {
      name
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}`;
export const CardContainer_Swnz_CardContainerFragmentDoc = /*#__PURE__*/ gql`
    fragment cardContainer_SWNZ_CardContainer on SWNZ_CardContainer {
  ...entryId_SWNZ_Entry
  title
  introText
  identifier
  display
  backgroundColour
  applyCardBackgroundColour
  cardsWithLinkCollection(limit: 30) {
    items {
      ...cardWithLink_SWNZ_CardWithLink
    }
  }
  cardsWithModalCollection(limit: 30) {
    items {
      ...cardWithModal_SWNZ_CardWithModal
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${CardWithLink_Swnz_CardWithLinkFragmentDoc}
${CardWithModal_Swnz_CardWithModalFragmentDoc}`;
export const StaticComponent_Swnz_ComponentStaticFragmentDoc = /*#__PURE__*/ gql`
    fragment staticComponent_SWNZ_ComponentStatic on SWNZ_ComponentStatic {
  ...entryId_SWNZ_Entry
  codeId
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const Statistic_Swnz_StatFragmentDoc = /*#__PURE__*/ gql`
    fragment statistic_SWNZ_Stat on SWNZ_Stat {
  ...entryId_SWNZ_Entry
  title
  statistic
  bodyText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}`;
export const Statistics_Swnz_StatContainerFragmentDoc = /*#__PURE__*/ gql`
    fragment statistics_SWNZ_StatContainer on SWNZ_StatContainer {
  ...entryId_SWNZ_Entry
  statsCollection(limit: 3) {
    items {
      ...statistic_SWNZ_Stat
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Statistic_Swnz_StatFragmentDoc}`;
export const StatsImageCarousel_Swnz_StatsImageCarouselFragmentDoc = /*#__PURE__*/ gql`
    fragment statsImageCarousel_SWNZ_StatsImageCarousel on SWNZ_StatsImageCarousel {
  ...entryId_SWNZ_Entry
  title
  statCardImagesCollection(limit: 8) {
    items {
      ...mediaImage_SWNZ_MediaImage
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}`;
export const Tag_Swnz_TagFragmentDoc = /*#__PURE__*/ gql`
    fragment tag_SWNZ_Tag on SWNZ_Tag {
  ...entryId_SWNZ_Entry
  label
  key
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const StoryCard_Swnz_StoryCardFragmentDoc = /*#__PURE__*/ gql`
    fragment storyCard_SWNZ_StoryCard on SWNZ_StoryCard {
  ...entryId_SWNZ_Entry
  name: studentName
  areaOfStudy
  location
  tagRefCollection(limit: 10) {
    items {
      ...tag_SWNZ_Tag
    }
  }
  image {
    ...mediaImage_SWNZ_MediaImage
  }
  modalContent {
    ...entryId_SWNZ_Entry
    __typename
    hero {
      ...entryId_SWNZ_Entry
      __typename
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Tag_Swnz_TagFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}`;
export const StoryCardContainer_Swnz_StoryCardContainerFragmentDoc = /*#__PURE__*/ gql`
    fragment storyCardContainer_SWNZ_StoryCardContainer on SWNZ_StoryCardContainer {
  ...entryId_SWNZ_Entry
  title
  backgroundColour
  subHeading
  tagFilterCollection(limit: 10) {
    items {
      ...tag_SWNZ_Tag
    }
  }
  storyCardsCollection(limit: 9) {
    items {
      ...storyCard_SWNZ_StoryCard
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Tag_Swnz_TagFragmentDoc}
${StoryCard_Swnz_StoryCardFragmentDoc}`;
export const Tile_Swnz_TileFragmentDoc = /*#__PURE__*/ gql`
    fragment tile_SWNZ_Tile on SWNZ_Tile {
  ...entryId_SWNZ_Entry
  title
  subtitle
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
  secondaryCta {
    ...cta_SWNZ_CallToAction
  }
  bodyText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
          ... on SWNZ_Glossary {
            ...glossary_SWNZ_Glossary
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
      }
    }
  }
  image {
    ... on SWNZ_MediaImage {
      ...mediaImage_SWNZ_MediaImage
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Glossary_Swnz_GlossaryFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}`;
export const TileContainer_Swnz_TileContainerFragmentDoc = /*#__PURE__*/ gql`
    fragment tileContainer_SWNZ_TileContainer on SWNZ_TileContainer {
  ...entryId_SWNZ_Entry
  codeId
  title
  columns
  introText
  tilesCollection(limit: 6) {
    items {
      ...tile_SWNZ_Tile
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Tile_Swnz_TileFragmentDoc}`;
export const Value_Swnz_ValueFragmentDoc = /*#__PURE__*/ gql`
    fragment value_SWNZ_Value on SWNZ_Value {
  ...entryId_SWNZ_Entry
  title
  introduction
  ctaText
  drawerPronunciation
  drawerPrimaryCta {
    ...cta_SWNZ_CallToAction
  }
  image {
    ...assetId_SWNZ_Asset
    url
    title
  }
  drawerDescription {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}
${AssetId_Swnz_AssetFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}`;
export const CourseDetail_InventoryCourseFragmentDoc = /*#__PURE__*/ gql`
    fragment courseDetail_inventoryCourse on inventoryCourse {
  id
  name
  active
  provider {
    name
    id
    logoUrl
    url
    campuses {
      id
      name
      email
      active
      region {
        tag
        name
      }
    }
    type {
      tag
      name
    }
    subtype {
      tag
      name
    }
    subtypeList {
      tag
      name
    }
  }
  areasOfStudy {
    name
    tag
  }
  subjectsOfStudy {
    name
    tag
  }
  levelOfStudy {
    name
    tag
  }
  intakes {
    id
    enrolmentDeadline
    startDate
    campus
    modeOfStudy
    duration
    deliveryMode {
      tag
      name
    }
  }
  details
  department
  nzqaLevel
  entryRequirements
}
    `;
export const Disclaimer_Swnz_GlobalSettingsCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment disclaimer_SWNZ_GlobalSettingsCollection on SWNZ_GlobalSettingsCollection {
  items {
    sys {
      id
    }
    richText {
      json
    }
  }
}
    `;
export const ProviderAttributes_ProviderAttributesFragmentDoc = /*#__PURE__*/ gql`
    fragment providerAttributes_providerAttributes on providerAttributes {
  ACCOMMODATION
  NUMBER_OF_INTERNATIONAL_STUDENTS
  NUMBER_OF_STUDENTS
  RELIGIOUS_CLUB
  RELIGIOUS_FACILITIES
}
    `;
export const TaxonomyObject_TaxonomyObjectFragmentDoc = /*#__PURE__*/ gql`
    fragment taxonomyObject_taxonomyObject on taxonomyObject {
  name
  tag
}
    `;
export const ProviderDetail_InventoryProviderFragmentDoc = /*#__PURE__*/ gql`
    fragment providerDetail_inventoryProvider on inventoryProvider {
  active
  attributes {
    ...providerAttributes_providerAttributes
  }
  campuses {
    address
    active
    attributes {
      ...providerAttributes_providerAttributes
    }
    city
    country {
      ...taxonomyObject_taxonomyObject
    }
    description
    email
    id
    name
    phone
    postcode
    region {
      ...taxonomyObject_taxonomyObject
    }
  }
  defaultCampus
  description
  id
  logoUrl
  profileImages
  name
  subtype {
    ...taxonomyObject_taxonomyObject
  }
  subtypeList {
    ...taxonomyObject_taxonomyObject
  }
  type {
    ...taxonomyObject_taxonomyObject
  }
  url
}
    ${ProviderAttributes_ProviderAttributesFragmentDoc}
${TaxonomyObject_TaxonomyObjectFragmentDoc}`;
export const ScholarshipDetail_InventoryScholarshipFragmentDoc = /*#__PURE__*/ gql`
    fragment scholarshipDetail_inventoryScholarship on inventoryScholarship {
  active
  __typename
  id
  title
  displayValue
  numberOfAwards
  applicationDeadlines
  providerId
  providerName
  url
  providerLogoUrl
  providerType {
    ...taxonomyObject_taxonomyObject
  }
  providerSubtypeList {
    ...taxonomyObject_taxonomyObject
  }
  eligibilityCriteria
  applicationInstructions
}
    ${TaxonomyObject_TaxonomyObjectFragmentDoc}`;
export const StudyInNzDetailBanner_Swnz_GlobalSettingsCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment studyInNzDetailBanner_SWNZ_GlobalSettingsCollection on SWNZ_GlobalSettingsCollection {
  items {
    sys {
      id
    }
    richText {
      json
    }
    callToActionCollection(limit: 3) {
      items {
        ...cta_SWNZ_CallToAction
      }
    }
  }
}
    ${Cta_Swnz_CallToActionFragmentDoc}`;
export const MediaIconFragmentDoc = /*#__PURE__*/ gql`
    fragment mediaIcon on SWNZ_MediaIcon {
  ...entryId_SWNZ_Entry
  source {
    ...assetId_SWNZ_Asset
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${AssetId_Swnz_AssetFragmentDoc}`;
export const NaumaiPageSlugs_Swnz_NaumaiPageStandardFragmentDoc = /*#__PURE__*/ gql`
    fragment naumaiPageSlugs_SWNZ_NaumaiPageStandard on SWNZ_NaumaiPageStandard {
  ...entryId_SWNZ_Entry
  slug
  parentPage {
    ...entryId_SWNZ_Entry
    slug
    parentPage {
      ...entryId_SWNZ_Entry
      slug
      parentPage {
        ...entryId_SWNZ_Entry
        slug
        parentPage {
          ...entryId_SWNZ_Entry
          slug
          parentPage {
            ...entryId_SWNZ_Entry
            slug
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const Seo_Swnz_SeoFragmentDoc = /*#__PURE__*/ gql`
    fragment seo_SWNZ_Seo on SWNZ_Seo {
  ...entryId_SWNZ_Entry
  title
  name
  description
  keywords
  noindex: noIndex
  nofollow: noFollow
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const NaumaiSitemapPage_Swnz_NaumaiPageStandardFragmentDoc = /*#__PURE__*/ gql`
    fragment naumaiSitemapPage_SWNZ_NaumaiPageStandard on SWNZ_NaumaiPageStandard {
  title
  slug
  ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
  seo {
    ...seo_SWNZ_Seo
  }
}
    ${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Seo_Swnz_SeoFragmentDoc}`;
export const NaumaiSitemapPages_Swnz_NaumaiPageCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment naumaiSitemapPages_SWNZ_NaumaiPageCollection on SWNZ_NaumaiPageStandardCollection {
  items {
    ...naumaiSitemapPage_SWNZ_NaumaiPageStandard
  }
}
    ${NaumaiSitemapPage_Swnz_NaumaiPageStandardFragmentDoc}`;
export const NaumaiStandardPageSlugs_Swnz_NaumaiPageStandardFragmentDoc = /*#__PURE__*/ gql`
    fragment naumaiStandardPageSlugs_SWNZ_NaumaiPageStandard on SWNZ_NaumaiPageStandard {
  ...entryId_SWNZ_Entry
  slug
  parentPage {
    ...entryId_SWNZ_Entry
    slug
    parentPage {
      ...entryId_SWNZ_Entry
      slug
      parentPage {
        ...entryId_SWNZ_Entry
        slug
        parentPage {
          ...entryId_SWNZ_Entry
          slug
          parentPage {
            ...entryId_SWNZ_Entry
            slug
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const NavigationElement_Swnz_NavigationElementFragmentDoc = /*#__PURE__*/ gql`
    fragment navigationElement_SWNZ_NavigationElement on SWNZ_NavigationElement {
  ...entryId_SWNZ_Entry
  title
  codeId
  customUrl
  openLinkInNewWindow
  internalPageLink {
    ...entryId_SWNZ_Entry
    ... on SWNZ_Page {
      ...parentPagePath_SWNZ_Page
    }
    ... on SWNZ_NaumaiPageStandard {
      ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}`;
export const NavigationElements_Swnz_NavigationNavigationElementsCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment navigationElements_SWNZ_NavigationNavigationElementsCollection on SWNZ_NavigationNavigationElementsCollection {
  items {
    ... on SWNZ_NavigationElement {
      ...navigationElement_SWNZ_NavigationElement
      navigationElementsCollection(limit: 10) {
        items {
          ... on SWNZ_NavigationElement {
            ...navigationElement_SWNZ_NavigationElement
            navigationElementsCollection(limit: 10) {
              items {
                ... on SWNZ_NavigationElement {
                  ...navigationElement_SWNZ_NavigationElement
                  navigationElementsCollection(limit: 5) {
                    items {
                      ... on SWNZ_NavigationElement {
                        ...navigationElement_SWNZ_NavigationElement
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${NavigationElement_Swnz_NavigationElementFragmentDoc}`;
export const StandardPageSectionItems_Swnz_PageStandardSectionsItemFragmentDoc = /*#__PURE__*/ gql`
    fragment standardPageSectionItems_SWNZ_PageStandardSectionsItem on SWNZ_PageStandardSectionsItem {
  ...entryId_SWNZ_Entry
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const StandardPage_Swnz_PageStandardFragmentDoc = /*#__PURE__*/ gql`
    fragment standardPage_SWNZ_PageStandard on SWNZ_PageStandard {
  ...entryId_SWNZ_Entry
  hero {
    ...entryId_SWNZ_Entry
  }
  intro {
    ...entryId_SWNZ_Entry
    ... on SWNZ_GenericText {
      backgroundColour
    }
  }
  tags
  sectionsCollection(limit: 30) {
    items {
      ...standardPageSectionItems_SWNZ_PageStandardSectionsItem
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${StandardPageSectionItems_Swnz_PageStandardSectionsItemFragmentDoc}`;
export const ModalPageSectionItems_Swnz_PageModalSectionsItemFragmentDoc = /*#__PURE__*/ gql`
    fragment modalPageSectionItems_SWNZ_PageModalSectionsItem on SWNZ_PageModalSectionsItem {
  ...entryId_SWNZ_Entry
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const ModalPage_Swnz_PageModalFragmentDoc = /*#__PURE__*/ gql`
    fragment modalPage_SWNZ_PageModal on SWNZ_PageModal {
  ...entryId_SWNZ_Entry
  hero {
    ...mediaImage_SWNZ_MediaImage
    ...mediaVideo_SWNZ_MediaVideo
  }
  sectionsCollection(limit: 30) {
    items {
      ...modalPageSectionItems_SWNZ_PageModalSectionsItem
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}
${MediaVideo_Swnz_MediaVideoFragmentDoc}
${ModalPageSectionItems_Swnz_PageModalSectionsItemFragmentDoc}`;
export const SearchResultsPage_Swnz_PageSearchResultsFragmentDoc = /*#__PURE__*/ gql`
    fragment searchResultsPage_SWNZ_PageSearchResults on SWNZ_PageSearchResults {
  ...entryId_SWNZ_Entry
  keepExploring {
    ...entryId_SWNZ_Entry
  }
  promo {
    ...entryId_SWNZ_Entry
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const Page_Swnz_PageFragmentDoc = /*#__PURE__*/ gql`
    fragment page_SWNZ_Page on SWNZ_Page {
  codeId
  ...entryId_SWNZ_Entry
  ...parentPagePath_SWNZ_Page
  seo {
    ...seo_SWNZ_Seo
  }
  content {
    ...entryId_SWNZ_Entry
    ... on SWNZ_PageStandard {
      ...standardPage_SWNZ_PageStandard
    }
    ... on SWNZ_PageModal {
      ...modalPage_SWNZ_PageModal
    }
    ... on SWNZ_PageSearchResults {
      ...searchResultsPage_SWNZ_PageSearchResults
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${Seo_Swnz_SeoFragmentDoc}
${StandardPage_Swnz_PageStandardFragmentDoc}
${ModalPage_Swnz_PageModalFragmentDoc}
${SearchResultsPage_Swnz_PageSearchResultsFragmentDoc}`;
export const PageSlugs_Swnz_PageFragmentDoc = /*#__PURE__*/ gql`
    fragment pageSlugs_SWNZ_Page on SWNZ_Page {
  ...entryId_SWNZ_Entry
  slug
  parentPage {
    ...entryId_SWNZ_Entry
    slug
    parentPage {
      ...entryId_SWNZ_Entry
      slug
      parentPage {
        ...entryId_SWNZ_Entry
        slug
        parentPage {
          ...entryId_SWNZ_Entry
          slug
          parentPage {
            ...entryId_SWNZ_Entry
            slug
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const SitemapPage_Swnz_PageFragmentDoc = /*#__PURE__*/ gql`
    fragment sitemapPage_SWNZ_Page on SWNZ_Page {
  title
  slug
  ...parentPagePath_SWNZ_Page
  seo {
    ...seo_SWNZ_Seo
  }
}
    ${ParentPagePath_Swnz_PageFragmentDoc}
${Seo_Swnz_SeoFragmentDoc}`;
export const SitemapPages_Swnz_PageCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment sitemapPages_SWNZ_PageCollection on SWNZ_PageCollection {
  items {
    ...sitemapPage_SWNZ_Page
  }
}
    ${SitemapPage_Swnz_PageFragmentDoc}`;
export const CtaBanner_Swnz_BannerFragmentDoc = /*#__PURE__*/ gql`
    fragment ctaBanner_SWNZ_Banner on SWNZ_Banner {
  ...entryId_SWNZ_Entry
  codeId
  title
  bodyText {
    json
    links {
      entries {
        hyperlink {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
        block {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
        inline {
          ...entryId_SWNZ_Entry
          ... on SWNZ_Page {
            ...parentPagePath_SWNZ_Page
          }
          ... on SWNZ_NaumaiPageStandard {
            ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
          }
        }
      }
    }
  }
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
  secondaryCta {
    ...cta_SWNZ_CallToAction
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const NavigationSection_Swnz_NavigationSectionFragmentDoc = /*#__PURE__*/ gql`
    fragment navigationSection_SWNZ_NavigationSection on SWNZ_NavigationSection {
  ...entryId_SWNZ_Entry
  codeId
  title
  sectionDescription
  quickLinksTitle
  quickLinksCollection(limit: 6) {
    items {
      ...entryId_SWNZ_Entry
      title
      codeId
      customUrl
      openLinkInNewWindow
      internalPageLink {
        ... on SWNZ_Page {
          ...parentPagePath_SWNZ_Page
        }
        ... on SWNZ_NaumaiPageStandard {
          ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
        }
      }
    }
  }
  navigationElementsCollection(limit: 10) {
    items {
      ... on SWNZ_NavigationElement {
        ...navigationElement_SWNZ_NavigationElement
        navigationElementsCollection(limit: 10) {
          items {
            ... on SWNZ_NavigationElement {
              ...navigationElement_SWNZ_NavigationElement
              navigationElementsCollection(limit: 5) {
                items {
                  ... on SWNZ_NavigationElement {
                    ...navigationElement_SWNZ_NavigationElement
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  featuredStoryCollection(limit: 2) {
    items {
      ...cardWithLink_SWNZ_CardWithLink
    }
  }
  ctaBannerDefault {
    ...ctaBanner_SWNZ_Banner
  }
  ctaBannerLoggedIn {
    ...ctaBanner_SWNZ_Banner
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${NavigationElement_Swnz_NavigationElementFragmentDoc}
${CardWithLink_Swnz_CardWithLinkFragmentDoc}
${CtaBanner_Swnz_BannerFragmentDoc}`;
export const SwnzNavigationElements_Swnz_NavigationNavigationElementsCollectionFragmentDoc = /*#__PURE__*/ gql`
    fragment swnzNavigationElements_SWNZ_NavigationNavigationElementsCollection on SWNZ_NavigationNavigationElementsCollection {
  items {
    ... on SWNZ_NavigationSection {
      ...navigationSection_SWNZ_NavigationSection
    }
  }
}
    ${NavigationSection_Swnz_NavigationSectionFragmentDoc}`;
export const HeroMediaItem_Swnz_HeroMediaItemFragmentDoc = /*#__PURE__*/ gql`
    fragment heroMediaItem_SWNZ_HeroMediaItem on SWNZ_HeroMediaItem {
  ... on SWNZ_MediaImage {
    ...mediaImage_SWNZ_MediaImage
  }
  ... on SWNZ_MediaVideo {
    ...mediaVideo_SWNZ_MediaVideo
  }
}
    ${MediaImage_Swnz_MediaImageFragmentDoc}
${MediaVideo_Swnz_MediaVideoFragmentDoc}`;
export const Hero_Swnz_HeroFragmentDoc = /*#__PURE__*/ gql`
    fragment hero_SWNZ_Hero on SWNZ_Hero {
  ...entryId_SWNZ_Entry
  backgroundColour
  displayType
  heading
  heroBackgroundVideo {
    ...asset_SWNZ_Asset
  }
  mediaItem {
    ...heroMediaItem_SWNZ_HeroMediaItem
  }
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Asset_Swnz_AssetFragmentDoc}
${HeroMediaItem_Swnz_HeroMediaItemFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export const HeroFeaturedMediaItem_Swnz_HeroFeaturedMediaItemFragmentDoc = /*#__PURE__*/ gql`
    fragment heroFeaturedMediaItem_SWNZ_HeroFeaturedMediaItem on SWNZ_HeroFeaturedMediaItem {
  ... on SWNZ_MediaImage {
    ...mediaImage_SWNZ_MediaImage
  }
  ... on SWNZ_MediaVideo {
    ...mediaVideo_SWNZ_MediaVideo
  }
}
    ${MediaImage_Swnz_MediaImageFragmentDoc}
${MediaVideo_Swnz_MediaVideoFragmentDoc}`;
export const HeroFeaturedFloatingCard_Swnz_HeroFeaturedFloatingCardFragmentDoc = /*#__PURE__*/ gql`
    fragment heroFeaturedFloatingCard_SWNZ_HeroFeaturedFloatingCard on SWNZ_HeroFeaturedFloatingCard {
  ...entryId_SWNZ_Entry
  cardHeading
  title
  internalLink {
    ...mediaVideo_SWNZ_MediaVideo
    ... on SWNZ_NaumaiPageStandard {
      ...entryId_SWNZ_Entry
      ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
      title
      hero {
        ...entryId_SWNZ_Entry
        ... on SWNZ_Hero {
          ...hero_SWNZ_Hero
        }
        ... on SWNZ_HeroFeatured {
          ...entryId_SWNZ_Entry
          heading
          subHeading
          mediaItem {
            ...heroFeaturedMediaItem_SWNZ_HeroFeaturedMediaItem
          }
        }
      }
    }
    ... on SWNZ_Page {
      ...entryId_SWNZ_Entry
      ...parentPagePath_SWNZ_Page
      slug
      title
      content {
        ... on SWNZ_PageStandard {
          ...entryId_SWNZ_Entry
          hero {
            ... on SWNZ_Hero {
              ...hero_SWNZ_Hero
            }
            ... on SWNZ_HeroFeatured {
              ...entryId_SWNZ_Entry
              heading
              subHeading
              mediaItem {
                ...heroFeaturedMediaItem_SWNZ_HeroFeaturedMediaItem
              }
            }
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${MediaVideo_Swnz_MediaVideoFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Hero_Swnz_HeroFragmentDoc}
${HeroFeaturedMediaItem_Swnz_HeroFeaturedMediaItemFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}`;
export const HeroFeatured_Swnz_HeroFeaturedFragmentDoc = /*#__PURE__*/ gql`
    fragment heroFeatured_SWNZ_HeroFeatured on SWNZ_HeroFeatured {
  ...entryId_SWNZ_Entry
  heading
  subHeading
  introText
  textThemeColour
  mediaItem {
    ...heroFeaturedMediaItem_SWNZ_HeroFeaturedMediaItem
  }
  primaryCta {
    ...cta_SWNZ_CallToAction
  }
  secondaryCta {
    ...cta_SWNZ_CallToAction
  }
  heroFloatingCard {
    ...heroFeaturedFloatingCard_SWNZ_HeroFeaturedFloatingCard
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${HeroFeaturedMediaItem_Swnz_HeroFeaturedMediaItemFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}
${HeroFeaturedFloatingCard_Swnz_HeroFeaturedFloatingCardFragmentDoc}`;
export const StandardPageNaumai_Swnz_NaumaiPageStandardFragmentDoc = /*#__PURE__*/ gql`
    fragment standardPageNaumai_SWNZ_NaumaiPageStandard on SWNZ_NaumaiPageStandard {
  ...entryId_SWNZ_Entry
  title
  ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
  seo {
    ...seo_SWNZ_Seo
  }
  intro {
    ...entryId_SWNZ_Entry
  }
  hero {
    ...entryId_SWNZ_Entry
    ... on SWNZ_Hero {
      ...hero_SWNZ_Hero
    }
    ... on SWNZ_HeroFeatured {
      ...heroFeatured_SWNZ_HeroFeatured
    }
  }
  sectionsCollection(limit: 30) {
    items {
      ...entryId_SWNZ_Entry
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}
${Seo_Swnz_SeoFragmentDoc}
${Hero_Swnz_HeroFragmentDoc}
${HeroFeatured_Swnz_HeroFeaturedFragmentDoc}`;
export const StandardNaumaiPageSectionItems_Swnz_NaumaiPageStandardSectionsItemFragmentDoc = /*#__PURE__*/ gql`
    fragment standardNaumaiPageSectionItems_SWNZ_NaumaiPageStandardSectionsItem on SWNZ_NaumaiPageStandardSectionsItem {
  ...entryId_SWNZ_Entry
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export const GetAccordionByIdDocument = /*#__PURE__*/ gql`
    query getAccordionById($id: String!, $locale: String, $preview: Boolean) {
  swnz_accordionContainer(id: $id, locale: $locale, preview: $preview) {
    ...accordion_SWNZ_AccordionContainer
  }
}
    ${Accordion_Swnz_AccordionContainerFragmentDoc}`;
export function useGetAccordionByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAccordionByIdQuery, Types.GetAccordionByIdQueryVariables> & ({ variables: Types.GetAccordionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAccordionByIdQuery, Types.GetAccordionByIdQueryVariables>(GetAccordionByIdDocument, options);
      }
export function useGetAccordionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAccordionByIdQuery, Types.GetAccordionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAccordionByIdQuery, Types.GetAccordionByIdQueryVariables>(GetAccordionByIdDocument, options);
        }
export function useGetAccordionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAccordionByIdQuery, Types.GetAccordionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAccordionByIdQuery, Types.GetAccordionByIdQueryVariables>(GetAccordionByIdDocument, options);
        }
export type GetAccordionByIdQueryHookResult = ReturnType<typeof useGetAccordionByIdQuery>;
export type GetAccordionByIdLazyQueryHookResult = ReturnType<typeof useGetAccordionByIdLazyQuery>;
export type GetAccordionByIdSuspenseQueryHookResult = ReturnType<typeof useGetAccordionByIdSuspenseQuery>;
export type GetAccordionByIdQueryResult = Apollo.QueryResult<Types.GetAccordionByIdQuery, Types.GetAccordionByIdQueryVariables>;
export const GetAlternatingContentByIdDocument = /*#__PURE__*/ gql`
    query getAlternatingContentById($id: String!, $locale: String, $preview: Boolean) {
  swnz_alternatingContent(id: $id, locale: $locale, preview: $preview) {
    ...alternatingContent_SWNZ_AlternatingContent
  }
}
    ${AlternatingContent_Swnz_AlternatingContentFragmentDoc}`;
export function useGetAlternatingContentByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAlternatingContentByIdQuery, Types.GetAlternatingContentByIdQueryVariables> & ({ variables: Types.GetAlternatingContentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAlternatingContentByIdQuery, Types.GetAlternatingContentByIdQueryVariables>(GetAlternatingContentByIdDocument, options);
      }
export function useGetAlternatingContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAlternatingContentByIdQuery, Types.GetAlternatingContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAlternatingContentByIdQuery, Types.GetAlternatingContentByIdQueryVariables>(GetAlternatingContentByIdDocument, options);
        }
export function useGetAlternatingContentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAlternatingContentByIdQuery, Types.GetAlternatingContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAlternatingContentByIdQuery, Types.GetAlternatingContentByIdQueryVariables>(GetAlternatingContentByIdDocument, options);
        }
export type GetAlternatingContentByIdQueryHookResult = ReturnType<typeof useGetAlternatingContentByIdQuery>;
export type GetAlternatingContentByIdLazyQueryHookResult = ReturnType<typeof useGetAlternatingContentByIdLazyQuery>;
export type GetAlternatingContentByIdSuspenseQueryHookResult = ReturnType<typeof useGetAlternatingContentByIdSuspenseQuery>;
export type GetAlternatingContentByIdQueryResult = Apollo.QueryResult<Types.GetAlternatingContentByIdQuery, Types.GetAlternatingContentByIdQueryVariables>;
export const GetAlternatingQuoteByIdDocument = /*#__PURE__*/ gql`
    query getAlternatingQuoteById($id: String!, $locale: String, $preview: Boolean) {
  swnz_alternatingQuote(id: $id, locale: $locale, preview: $preview) {
    ...alternatingQuote_SWNZ_AlternatingQuote
  }
}
    ${AlternatingQuote_Swnz_AlternatingQuoteFragmentDoc}`;
export function useGetAlternatingQuoteByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAlternatingQuoteByIdQuery, Types.GetAlternatingQuoteByIdQueryVariables> & ({ variables: Types.GetAlternatingQuoteByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAlternatingQuoteByIdQuery, Types.GetAlternatingQuoteByIdQueryVariables>(GetAlternatingQuoteByIdDocument, options);
      }
export function useGetAlternatingQuoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAlternatingQuoteByIdQuery, Types.GetAlternatingQuoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAlternatingQuoteByIdQuery, Types.GetAlternatingQuoteByIdQueryVariables>(GetAlternatingQuoteByIdDocument, options);
        }
export function useGetAlternatingQuoteByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAlternatingQuoteByIdQuery, Types.GetAlternatingQuoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAlternatingQuoteByIdQuery, Types.GetAlternatingQuoteByIdQueryVariables>(GetAlternatingQuoteByIdDocument, options);
        }
export type GetAlternatingQuoteByIdQueryHookResult = ReturnType<typeof useGetAlternatingQuoteByIdQuery>;
export type GetAlternatingQuoteByIdLazyQueryHookResult = ReturnType<typeof useGetAlternatingQuoteByIdLazyQuery>;
export type GetAlternatingQuoteByIdSuspenseQueryHookResult = ReturnType<typeof useGetAlternatingQuoteByIdSuspenseQuery>;
export type GetAlternatingQuoteByIdQueryResult = Apollo.QueryResult<Types.GetAlternatingQuoteByIdQuery, Types.GetAlternatingQuoteByIdQueryVariables>;
export const GetBulletPointsByIdDocument = /*#__PURE__*/ gql`
    query getBulletPointsById($id: String!, $locale: String, $preview: Boolean) {
  swnz_bulletPointContainer(id: $id, locale: $locale, preview: $preview) {
    ...bulletPoints_SWNZ_BulletPointContainer
  }
}
    ${BulletPoints_Swnz_BulletPointContainerFragmentDoc}`;
export function useGetBulletPointsByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetBulletPointsByIdQuery, Types.GetBulletPointsByIdQueryVariables> & ({ variables: Types.GetBulletPointsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetBulletPointsByIdQuery, Types.GetBulletPointsByIdQueryVariables>(GetBulletPointsByIdDocument, options);
      }
export function useGetBulletPointsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBulletPointsByIdQuery, Types.GetBulletPointsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetBulletPointsByIdQuery, Types.GetBulletPointsByIdQueryVariables>(GetBulletPointsByIdDocument, options);
        }
export function useGetBulletPointsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetBulletPointsByIdQuery, Types.GetBulletPointsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetBulletPointsByIdQuery, Types.GetBulletPointsByIdQueryVariables>(GetBulletPointsByIdDocument, options);
        }
export type GetBulletPointsByIdQueryHookResult = ReturnType<typeof useGetBulletPointsByIdQuery>;
export type GetBulletPointsByIdLazyQueryHookResult = ReturnType<typeof useGetBulletPointsByIdLazyQuery>;
export type GetBulletPointsByIdSuspenseQueryHookResult = ReturnType<typeof useGetBulletPointsByIdSuspenseQuery>;
export type GetBulletPointsByIdQueryResult = Apollo.QueryResult<Types.GetBulletPointsByIdQuery, Types.GetBulletPointsByIdQueryVariables>;
export const GetFormLeadCaptureByIdDocument = /*#__PURE__*/ gql`
    query getFormLeadCaptureById($id: String!, $locale: String, $preview: Boolean) {
  swnz_formLeadCapture(id: $id, locale: $locale, preview: $preview) {
    ...formLeadCapture_Swnz_FormLeadCapture
  }
}
    ${FormLeadCapture_Swnz_FormLeadCaptureFragmentDoc}`;
export function useGetFormLeadCaptureByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetFormLeadCaptureByIdQuery, Types.GetFormLeadCaptureByIdQueryVariables> & ({ variables: Types.GetFormLeadCaptureByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetFormLeadCaptureByIdQuery, Types.GetFormLeadCaptureByIdQueryVariables>(GetFormLeadCaptureByIdDocument, options);
      }
export function useGetFormLeadCaptureByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetFormLeadCaptureByIdQuery, Types.GetFormLeadCaptureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetFormLeadCaptureByIdQuery, Types.GetFormLeadCaptureByIdQueryVariables>(GetFormLeadCaptureByIdDocument, options);
        }
export function useGetFormLeadCaptureByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetFormLeadCaptureByIdQuery, Types.GetFormLeadCaptureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetFormLeadCaptureByIdQuery, Types.GetFormLeadCaptureByIdQueryVariables>(GetFormLeadCaptureByIdDocument, options);
        }
export type GetFormLeadCaptureByIdQueryHookResult = ReturnType<typeof useGetFormLeadCaptureByIdQuery>;
export type GetFormLeadCaptureByIdLazyQueryHookResult = ReturnType<typeof useGetFormLeadCaptureByIdLazyQuery>;
export type GetFormLeadCaptureByIdSuspenseQueryHookResult = ReturnType<typeof useGetFormLeadCaptureByIdSuspenseQuery>;
export type GetFormLeadCaptureByIdQueryResult = Apollo.QueryResult<Types.GetFormLeadCaptureByIdQuery, Types.GetFormLeadCaptureByIdQueryVariables>;
export const GetEmotionByIdDocument = /*#__PURE__*/ gql`
    query getEmotionById($id: String!, $locale: String, $preview: Boolean) {
  swnz_emotionContainer(id: $id, locale: $locale, preview: $preview) {
    ...emotion_SWNZ_EmotionContainer
  }
}
    ${Emotion_Swnz_EmotionContainerFragmentDoc}`;
export function useGetEmotionByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetEmotionByIdQuery, Types.GetEmotionByIdQueryVariables> & ({ variables: Types.GetEmotionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEmotionByIdQuery, Types.GetEmotionByIdQueryVariables>(GetEmotionByIdDocument, options);
      }
export function useGetEmotionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEmotionByIdQuery, Types.GetEmotionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEmotionByIdQuery, Types.GetEmotionByIdQueryVariables>(GetEmotionByIdDocument, options);
        }
export function useGetEmotionByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetEmotionByIdQuery, Types.GetEmotionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetEmotionByIdQuery, Types.GetEmotionByIdQueryVariables>(GetEmotionByIdDocument, options);
        }
export type GetEmotionByIdQueryHookResult = ReturnType<typeof useGetEmotionByIdQuery>;
export type GetEmotionByIdLazyQueryHookResult = ReturnType<typeof useGetEmotionByIdLazyQuery>;
export type GetEmotionByIdSuspenseQueryHookResult = ReturnType<typeof useGetEmotionByIdSuspenseQuery>;
export type GetEmotionByIdQueryResult = Apollo.QueryResult<Types.GetEmotionByIdQuery, Types.GetEmotionByIdQueryVariables>;
export const GetEnquiryFormFieldsDocument = /*#__PURE__*/ gql`
    query getEnquiryFormFields($locale: String, $preview: Boolean) {
  agentUseField: swnz_formDropdownCollection(
    where: {codeId: "enquiry-agent-use"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...enquiryFormFields_SWNZ_FormDropdownCollection
  }
  levelOfEnglishField: swnz_formDropdownCollection(
    where: {codeId: "enquiry-english-level"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...enquiryFormFields_SWNZ_FormDropdownCollection
  }
  languageField: swnz_formDropdownCollection(
    where: {codeId: "enquiry-language"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...enquiryFormFields_SWNZ_FormDropdownCollection
  }
  moreInformationFieldOnCourses: swnz_formDropdownCollection(
    where: {codeId: "enquiry-request-more-info-on-course"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...enquiryFormFields_SWNZ_FormDropdownCollection
  }
  moreInformationFieldOnAgents: swnz_formDropdownCollection(
    where: {codeId: "enquiry-request-more-info-on-agents"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...enquiryFormFields_SWNZ_FormDropdownCollection
  }
  moreInformationFieldOnInstitutions: swnz_formDropdownCollection(
    where: {codeId: "enquiry-request-more-info-on-institution"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...enquiryFormFields_SWNZ_FormDropdownCollection
  }
  moreInformationFieldOnSchools: swnz_formDropdownCollection(
    where: {codeId: "enquiry-request-more-info-on-institution-school"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...enquiryFormFields_SWNZ_FormDropdownCollection
  }
  moreInformationFieldOnScholarships: swnz_formDropdownCollection(
    where: {codeId: "enquiry-request-more-info-on-scholarships"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...enquiryFormFields_SWNZ_FormDropdownCollection
  }
}
    ${EnquiryFormFields_Swnz_FormDropdownCollectionFragmentDoc}`;
export function useGetEnquiryFormFieldsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetEnquiryFormFieldsQuery, Types.GetEnquiryFormFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetEnquiryFormFieldsQuery, Types.GetEnquiryFormFieldsQueryVariables>(GetEnquiryFormFieldsDocument, options);
      }
export function useGetEnquiryFormFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetEnquiryFormFieldsQuery, Types.GetEnquiryFormFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetEnquiryFormFieldsQuery, Types.GetEnquiryFormFieldsQueryVariables>(GetEnquiryFormFieldsDocument, options);
        }
export function useGetEnquiryFormFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetEnquiryFormFieldsQuery, Types.GetEnquiryFormFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetEnquiryFormFieldsQuery, Types.GetEnquiryFormFieldsQueryVariables>(GetEnquiryFormFieldsDocument, options);
        }
export type GetEnquiryFormFieldsQueryHookResult = ReturnType<typeof useGetEnquiryFormFieldsQuery>;
export type GetEnquiryFormFieldsLazyQueryHookResult = ReturnType<typeof useGetEnquiryFormFieldsLazyQuery>;
export type GetEnquiryFormFieldsSuspenseQueryHookResult = ReturnType<typeof useGetEnquiryFormFieldsSuspenseQuery>;
export type GetEnquiryFormFieldsQueryResult = Apollo.QueryResult<Types.GetEnquiryFormFieldsQuery, Types.GetEnquiryFormFieldsQueryVariables>;
export const GetGalleryCarouselByIdDocument = /*#__PURE__*/ gql`
    query getGalleryCarouselById($id: String!, $locale: String, $preview: Boolean) {
  swnz_galleryCarousel(id: $id, locale: $locale, preview: $preview) {
    ...galleryCarousel_SWNZ_GalleryCarousel
  }
}
    ${GalleryCarousel_Swnz_GalleryCarouselFragmentDoc}`;
export function useGetGalleryCarouselByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetGalleryCarouselByIdQuery, Types.GetGalleryCarouselByIdQueryVariables> & ({ variables: Types.GetGalleryCarouselByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGalleryCarouselByIdQuery, Types.GetGalleryCarouselByIdQueryVariables>(GetGalleryCarouselByIdDocument, options);
      }
export function useGetGalleryCarouselByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGalleryCarouselByIdQuery, Types.GetGalleryCarouselByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGalleryCarouselByIdQuery, Types.GetGalleryCarouselByIdQueryVariables>(GetGalleryCarouselByIdDocument, options);
        }
export function useGetGalleryCarouselByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGalleryCarouselByIdQuery, Types.GetGalleryCarouselByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGalleryCarouselByIdQuery, Types.GetGalleryCarouselByIdQueryVariables>(GetGalleryCarouselByIdDocument, options);
        }
export type GetGalleryCarouselByIdQueryHookResult = ReturnType<typeof useGetGalleryCarouselByIdQuery>;
export type GetGalleryCarouselByIdLazyQueryHookResult = ReturnType<typeof useGetGalleryCarouselByIdLazyQuery>;
export type GetGalleryCarouselByIdSuspenseQueryHookResult = ReturnType<typeof useGetGalleryCarouselByIdSuspenseQuery>;
export type GetGalleryCarouselByIdQueryResult = Apollo.QueryResult<Types.GetGalleryCarouselByIdQuery, Types.GetGalleryCarouselByIdQueryVariables>;
export const GetGenericTextByIdDocument = /*#__PURE__*/ gql`
    query getGenericTextById($id: String!, $locale: String, $preview: Boolean) {
  swnz_genericText(id: $id, locale: $locale, preview: $preview) {
    ...genericText_SWNZ_GenericText
  }
}
    ${GenericText_Swnz_GenericTextFragmentDoc}`;
export function useGetGenericTextByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetGenericTextByIdQuery, Types.GetGenericTextByIdQueryVariables> & ({ variables: Types.GetGenericTextByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetGenericTextByIdQuery, Types.GetGenericTextByIdQueryVariables>(GetGenericTextByIdDocument, options);
      }
export function useGetGenericTextByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetGenericTextByIdQuery, Types.GetGenericTextByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetGenericTextByIdQuery, Types.GetGenericTextByIdQueryVariables>(GetGenericTextByIdDocument, options);
        }
export function useGetGenericTextByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetGenericTextByIdQuery, Types.GetGenericTextByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetGenericTextByIdQuery, Types.GetGenericTextByIdQueryVariables>(GetGenericTextByIdDocument, options);
        }
export type GetGenericTextByIdQueryHookResult = ReturnType<typeof useGetGenericTextByIdQuery>;
export type GetGenericTextByIdLazyQueryHookResult = ReturnType<typeof useGetGenericTextByIdLazyQuery>;
export type GetGenericTextByIdSuspenseQueryHookResult = ReturnType<typeof useGetGenericTextByIdSuspenseQuery>;
export type GetGenericTextByIdQueryResult = Apollo.QueryResult<Types.GetGenericTextByIdQuery, Types.GetGenericTextByIdQueryVariables>;
export const GetImpactTextByIdDocument = /*#__PURE__*/ gql`
    query getImpactTextById($id: String!, $locale: String, $preview: Boolean) {
  swnz_impactText(id: $id, locale: $locale, preview: $preview) {
    ...impactText_SWNZ_ImpactText
  }
}
    ${ImpactText_Swnz_ImpactTextFragmentDoc}`;
export function useGetImpactTextByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetImpactTextByIdQuery, Types.GetImpactTextByIdQueryVariables> & ({ variables: Types.GetImpactTextByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetImpactTextByIdQuery, Types.GetImpactTextByIdQueryVariables>(GetImpactTextByIdDocument, options);
      }
export function useGetImpactTextByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetImpactTextByIdQuery, Types.GetImpactTextByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetImpactTextByIdQuery, Types.GetImpactTextByIdQueryVariables>(GetImpactTextByIdDocument, options);
        }
export function useGetImpactTextByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetImpactTextByIdQuery, Types.GetImpactTextByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetImpactTextByIdQuery, Types.GetImpactTextByIdQueryVariables>(GetImpactTextByIdDocument, options);
        }
export type GetImpactTextByIdQueryHookResult = ReturnType<typeof useGetImpactTextByIdQuery>;
export type GetImpactTextByIdLazyQueryHookResult = ReturnType<typeof useGetImpactTextByIdLazyQuery>;
export type GetImpactTextByIdSuspenseQueryHookResult = ReturnType<typeof useGetImpactTextByIdSuspenseQuery>;
export type GetImpactTextByIdQueryResult = Apollo.QueryResult<Types.GetImpactTextByIdQuery, Types.GetImpactTextByIdQueryVariables>;
export const GetIntroTextWithJumpMenuDocument = /*#__PURE__*/ gql`
    query getIntroTextWithJumpMenu($id: String!, $locale: String, $preview: Boolean) {
  swnz_introTextWithJumpMenu(id: $id, locale: $locale, preview: $preview) {
    ...entryId_SWNZ_Entry
    bodyText {
      json
      links {
        entries {
          hyperlink {
            ...entryId_SWNZ_Entry
            ... on SWNZ_Page {
              ...parentPagePath_SWNZ_Page
            }
          }
          block {
            ...entryId_SWNZ_Entry
            ... on SWNZ_Page {
              ...parentPagePath_SWNZ_Page
            }
          }
          inline {
            ...entryId_SWNZ_Entry
            ... on SWNZ_Page {
              ...parentPagePath_SWNZ_Page
            }
          }
        }
      }
    }
    primaryCta {
      ...cta_SWNZ_CallToAction
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${Cta_Swnz_CallToActionFragmentDoc}`;
export function useGetIntroTextWithJumpMenuQuery(baseOptions: Apollo.QueryHookOptions<Types.GetIntroTextWithJumpMenuQuery, Types.GetIntroTextWithJumpMenuQueryVariables> & ({ variables: Types.GetIntroTextWithJumpMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetIntroTextWithJumpMenuQuery, Types.GetIntroTextWithJumpMenuQueryVariables>(GetIntroTextWithJumpMenuDocument, options);
      }
export function useGetIntroTextWithJumpMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetIntroTextWithJumpMenuQuery, Types.GetIntroTextWithJumpMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetIntroTextWithJumpMenuQuery, Types.GetIntroTextWithJumpMenuQueryVariables>(GetIntroTextWithJumpMenuDocument, options);
        }
export function useGetIntroTextWithJumpMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetIntroTextWithJumpMenuQuery, Types.GetIntroTextWithJumpMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetIntroTextWithJumpMenuQuery, Types.GetIntroTextWithJumpMenuQueryVariables>(GetIntroTextWithJumpMenuDocument, options);
        }
export type GetIntroTextWithJumpMenuQueryHookResult = ReturnType<typeof useGetIntroTextWithJumpMenuQuery>;
export type GetIntroTextWithJumpMenuLazyQueryHookResult = ReturnType<typeof useGetIntroTextWithJumpMenuLazyQuery>;
export type GetIntroTextWithJumpMenuSuspenseQueryHookResult = ReturnType<typeof useGetIntroTextWithJumpMenuSuspenseQuery>;
export type GetIntroTextWithJumpMenuQueryResult = Apollo.QueryResult<Types.GetIntroTextWithJumpMenuQuery, Types.GetIntroTextWithJumpMenuQueryVariables>;
export const GetJumpAheadByIdDocument = /*#__PURE__*/ gql`
    query getJumpAheadById($id: String!, $locale: String, $preview: Boolean) {
  swnz_jumpAhead(id: $id, locale: $locale, preview: $preview) {
    ...jumpAhead_SWNZ_JumpAhead
  }
}
    ${JumpAhead_Swnz_JumpAheadFragmentDoc}`;
export function useGetJumpAheadByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetJumpAheadByIdQuery, Types.GetJumpAheadByIdQueryVariables> & ({ variables: Types.GetJumpAheadByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetJumpAheadByIdQuery, Types.GetJumpAheadByIdQueryVariables>(GetJumpAheadByIdDocument, options);
      }
export function useGetJumpAheadByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetJumpAheadByIdQuery, Types.GetJumpAheadByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetJumpAheadByIdQuery, Types.GetJumpAheadByIdQueryVariables>(GetJumpAheadByIdDocument, options);
        }
export function useGetJumpAheadByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetJumpAheadByIdQuery, Types.GetJumpAheadByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetJumpAheadByIdQuery, Types.GetJumpAheadByIdQueryVariables>(GetJumpAheadByIdDocument, options);
        }
export type GetJumpAheadByIdQueryHookResult = ReturnType<typeof useGetJumpAheadByIdQuery>;
export type GetJumpAheadByIdLazyQueryHookResult = ReturnType<typeof useGetJumpAheadByIdLazyQuery>;
export type GetJumpAheadByIdSuspenseQueryHookResult = ReturnType<typeof useGetJumpAheadByIdSuspenseQuery>;
export type GetJumpAheadByIdQueryResult = Apollo.QueryResult<Types.GetJumpAheadByIdQuery, Types.GetJumpAheadByIdQueryVariables>;
export const GetKeepExploringByIdDocument = /*#__PURE__*/ gql`
    query getKeepExploringById($id: String!, $locale: String, $preview: Boolean) {
  swnz_keepExploring(id: $id, locale: $locale, preview: $preview) {
    ...keepExploring_SWNZ_KeepExploring
  }
}
    ${KeepExploring_Swnz_KeepExploringFragmentDoc}`;
export function useGetKeepExploringByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetKeepExploringByIdQuery, Types.GetKeepExploringByIdQueryVariables> & ({ variables: Types.GetKeepExploringByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetKeepExploringByIdQuery, Types.GetKeepExploringByIdQueryVariables>(GetKeepExploringByIdDocument, options);
      }
export function useGetKeepExploringByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetKeepExploringByIdQuery, Types.GetKeepExploringByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetKeepExploringByIdQuery, Types.GetKeepExploringByIdQueryVariables>(GetKeepExploringByIdDocument, options);
        }
export function useGetKeepExploringByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetKeepExploringByIdQuery, Types.GetKeepExploringByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetKeepExploringByIdQuery, Types.GetKeepExploringByIdQueryVariables>(GetKeepExploringByIdDocument, options);
        }
export type GetKeepExploringByIdQueryHookResult = ReturnType<typeof useGetKeepExploringByIdQuery>;
export type GetKeepExploringByIdLazyQueryHookResult = ReturnType<typeof useGetKeepExploringByIdLazyQuery>;
export type GetKeepExploringByIdSuspenseQueryHookResult = ReturnType<typeof useGetKeepExploringByIdSuspenseQuery>;
export type GetKeepExploringByIdQueryResult = Apollo.QueryResult<Types.GetKeepExploringByIdQuery, Types.GetKeepExploringByIdQueryVariables>;
export const GetMapContainerByIdDocument = /*#__PURE__*/ gql`
    query getMapContainerById($id: String!, $locale: String, $preview: Boolean) {
  swnz_mapContainer(id: $id, locale: $locale, preview: $preview) {
    ...mapContainer_SWNZ_MapContainer
  }
}
    ${MapContainer_Swnz_MapContainerFragmentDoc}`;
export function useGetMapContainerByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMapContainerByIdQuery, Types.GetMapContainerByIdQueryVariables> & ({ variables: Types.GetMapContainerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMapContainerByIdQuery, Types.GetMapContainerByIdQueryVariables>(GetMapContainerByIdDocument, options);
      }
export function useGetMapContainerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMapContainerByIdQuery, Types.GetMapContainerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMapContainerByIdQuery, Types.GetMapContainerByIdQueryVariables>(GetMapContainerByIdDocument, options);
        }
export function useGetMapContainerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMapContainerByIdQuery, Types.GetMapContainerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMapContainerByIdQuery, Types.GetMapContainerByIdQueryVariables>(GetMapContainerByIdDocument, options);
        }
export type GetMapContainerByIdQueryHookResult = ReturnType<typeof useGetMapContainerByIdQuery>;
export type GetMapContainerByIdLazyQueryHookResult = ReturnType<typeof useGetMapContainerByIdLazyQuery>;
export type GetMapContainerByIdSuspenseQueryHookResult = ReturnType<typeof useGetMapContainerByIdSuspenseQuery>;
export type GetMapContainerByIdQueryResult = Apollo.QueryResult<Types.GetMapContainerByIdQuery, Types.GetMapContainerByIdQueryVariables>;
export const GetMediaImageByIdDocument = /*#__PURE__*/ gql`
    query getMediaImageById($id: String!, $locale: String, $preview: Boolean) {
  swnz_mediaImage(id: $id, locale: $locale, preview: $preview) {
    ...mediaImage_SWNZ_MediaImage
  }
}
    ${MediaImage_Swnz_MediaImageFragmentDoc}`;
export function useGetMediaImageByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMediaImageByIdQuery, Types.GetMediaImageByIdQueryVariables> & ({ variables: Types.GetMediaImageByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMediaImageByIdQuery, Types.GetMediaImageByIdQueryVariables>(GetMediaImageByIdDocument, options);
      }
export function useGetMediaImageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMediaImageByIdQuery, Types.GetMediaImageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMediaImageByIdQuery, Types.GetMediaImageByIdQueryVariables>(GetMediaImageByIdDocument, options);
        }
export function useGetMediaImageByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMediaImageByIdQuery, Types.GetMediaImageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMediaImageByIdQuery, Types.GetMediaImageByIdQueryVariables>(GetMediaImageByIdDocument, options);
        }
export type GetMediaImageByIdQueryHookResult = ReturnType<typeof useGetMediaImageByIdQuery>;
export type GetMediaImageByIdLazyQueryHookResult = ReturnType<typeof useGetMediaImageByIdLazyQuery>;
export type GetMediaImageByIdSuspenseQueryHookResult = ReturnType<typeof useGetMediaImageByIdSuspenseQuery>;
export type GetMediaImageByIdQueryResult = Apollo.QueryResult<Types.GetMediaImageByIdQuery, Types.GetMediaImageByIdQueryVariables>;
export const GetMediaVideoByIdDocument = /*#__PURE__*/ gql`
    query getMediaVideoById($id: String!, $locale: String, $preview: Boolean) {
  swnz_mediaVideo(id: $id, locale: $locale, preview: $preview) {
    ...mediaVideo_SWNZ_MediaVideo
  }
}
    ${MediaVideo_Swnz_MediaVideoFragmentDoc}`;
export function useGetMediaVideoByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetMediaVideoByIdQuery, Types.GetMediaVideoByIdQueryVariables> & ({ variables: Types.GetMediaVideoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetMediaVideoByIdQuery, Types.GetMediaVideoByIdQueryVariables>(GetMediaVideoByIdDocument, options);
      }
export function useGetMediaVideoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetMediaVideoByIdQuery, Types.GetMediaVideoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetMediaVideoByIdQuery, Types.GetMediaVideoByIdQueryVariables>(GetMediaVideoByIdDocument, options);
        }
export function useGetMediaVideoByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetMediaVideoByIdQuery, Types.GetMediaVideoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetMediaVideoByIdQuery, Types.GetMediaVideoByIdQueryVariables>(GetMediaVideoByIdDocument, options);
        }
export type GetMediaVideoByIdQueryHookResult = ReturnType<typeof useGetMediaVideoByIdQuery>;
export type GetMediaVideoByIdLazyQueryHookResult = ReturnType<typeof useGetMediaVideoByIdLazyQuery>;
export type GetMediaVideoByIdSuspenseQueryHookResult = ReturnType<typeof useGetMediaVideoByIdSuspenseQuery>;
export type GetMediaVideoByIdQueryResult = Apollo.QueryResult<Types.GetMediaVideoByIdQuery, Types.GetMediaVideoByIdQueryVariables>;
export const GetNextStepsByIdDocument = /*#__PURE__*/ gql`
    query getNextStepsById($id: String!, $locale: String, $preview: Boolean) {
  swnz_nextSteps(id: $id, locale: $locale, preview: $preview) {
    ...nextSteps_SWNZ_NextSteps
  }
}
    ${NextSteps_Swnz_NextStepsFragmentDoc}`;
export function useGetNextStepsByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetNextStepsByIdQuery, Types.GetNextStepsByIdQueryVariables> & ({ variables: Types.GetNextStepsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNextStepsByIdQuery, Types.GetNextStepsByIdQueryVariables>(GetNextStepsByIdDocument, options);
      }
export function useGetNextStepsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNextStepsByIdQuery, Types.GetNextStepsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNextStepsByIdQuery, Types.GetNextStepsByIdQueryVariables>(GetNextStepsByIdDocument, options);
        }
export function useGetNextStepsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNextStepsByIdQuery, Types.GetNextStepsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNextStepsByIdQuery, Types.GetNextStepsByIdQueryVariables>(GetNextStepsByIdDocument, options);
        }
export type GetNextStepsByIdQueryHookResult = ReturnType<typeof useGetNextStepsByIdQuery>;
export type GetNextStepsByIdLazyQueryHookResult = ReturnType<typeof useGetNextStepsByIdLazyQuery>;
export type GetNextStepsByIdSuspenseQueryHookResult = ReturnType<typeof useGetNextStepsByIdSuspenseQuery>;
export type GetNextStepsByIdQueryResult = Apollo.QueryResult<Types.GetNextStepsByIdQuery, Types.GetNextStepsByIdQueryVariables>;
export const GetProfileFormFieldsDocument = /*#__PURE__*/ gql`
    query getProfileFormFields($locale: String, $preview: Boolean) {
  schoolOrientationField: swnz_formDropdownCollection(
    where: {codeId: "profile-do-you-want-a-single-sex-or-co-educational-school"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...profileFormFields_SWNZ_FormDropdownCollection
  }
  schoolAuthorityField: swnz_formDropdownCollection(
    where: {codeId: "profile-what-school-type-are-you-looking-for"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...profileFormFields_SWNZ_FormDropdownCollection
  }
  maxTuitionBudgetField: swnz_formDropdownCollection(
    where: {codeId: "profile-max-annual-tuition-budget"}
    limit: 1
    locale: $locale
    preview: $preview
  ) {
    ...profileFormFields_SWNZ_FormDropdownCollection
  }
}
    ${ProfileFormFields_Swnz_FormDropdownCollectionFragmentDoc}`;
export function useGetProfileFormFieldsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetProfileFormFieldsQuery, Types.GetProfileFormFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProfileFormFieldsQuery, Types.GetProfileFormFieldsQueryVariables>(GetProfileFormFieldsDocument, options);
      }
export function useGetProfileFormFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProfileFormFieldsQuery, Types.GetProfileFormFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProfileFormFieldsQuery, Types.GetProfileFormFieldsQueryVariables>(GetProfileFormFieldsDocument, options);
        }
export function useGetProfileFormFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetProfileFormFieldsQuery, Types.GetProfileFormFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetProfileFormFieldsQuery, Types.GetProfileFormFieldsQueryVariables>(GetProfileFormFieldsDocument, options);
        }
export type GetProfileFormFieldsQueryHookResult = ReturnType<typeof useGetProfileFormFieldsQuery>;
export type GetProfileFormFieldsLazyQueryHookResult = ReturnType<typeof useGetProfileFormFieldsLazyQuery>;
export type GetProfileFormFieldsSuspenseQueryHookResult = ReturnType<typeof useGetProfileFormFieldsSuspenseQuery>;
export type GetProfileFormFieldsQueryResult = Apollo.QueryResult<Types.GetProfileFormFieldsQuery, Types.GetProfileFormFieldsQueryVariables>;
export const GetPromoByIdDocument = /*#__PURE__*/ gql`
    query getPromoById($id: String!, $locale: String, $preview: Boolean) {
  swnz_promo(id: $id, locale: $locale, preview: $preview) {
    ...promo_SWNZ_Promo
  }
}
    ${Promo_Swnz_PromoFragmentDoc}`;
export function useGetPromoByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPromoByIdQuery, Types.GetPromoByIdQueryVariables> & ({ variables: Types.GetPromoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPromoByIdQuery, Types.GetPromoByIdQueryVariables>(GetPromoByIdDocument, options);
      }
export function useGetPromoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPromoByIdQuery, Types.GetPromoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPromoByIdQuery, Types.GetPromoByIdQueryVariables>(GetPromoByIdDocument, options);
        }
export function useGetPromoByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPromoByIdQuery, Types.GetPromoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPromoByIdQuery, Types.GetPromoByIdQueryVariables>(GetPromoByIdDocument, options);
        }
export type GetPromoByIdQueryHookResult = ReturnType<typeof useGetPromoByIdQuery>;
export type GetPromoByIdLazyQueryHookResult = ReturnType<typeof useGetPromoByIdLazyQuery>;
export type GetPromoByIdSuspenseQueryHookResult = ReturnType<typeof useGetPromoByIdSuspenseQuery>;
export type GetPromoByIdQueryResult = Apollo.QueryResult<Types.GetPromoByIdQuery, Types.GetPromoByIdQueryVariables>;
export const GetRegionCardsCarouselByIdDocument = /*#__PURE__*/ gql`
    query getRegionCardsCarouselById($id: String!, $locale: String, $preview: Boolean) {
  swnz_cardContainer(id: $id, locale: $locale, preview: $preview) {
    ...cardContainer_SWNZ_CardContainer
  }
}
    ${CardContainer_Swnz_CardContainerFragmentDoc}`;
export function useGetRegionCardsCarouselByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetRegionCardsCarouselByIdQuery, Types.GetRegionCardsCarouselByIdQueryVariables> & ({ variables: Types.GetRegionCardsCarouselByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetRegionCardsCarouselByIdQuery, Types.GetRegionCardsCarouselByIdQueryVariables>(GetRegionCardsCarouselByIdDocument, options);
      }
export function useGetRegionCardsCarouselByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetRegionCardsCarouselByIdQuery, Types.GetRegionCardsCarouselByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetRegionCardsCarouselByIdQuery, Types.GetRegionCardsCarouselByIdQueryVariables>(GetRegionCardsCarouselByIdDocument, options);
        }
export function useGetRegionCardsCarouselByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetRegionCardsCarouselByIdQuery, Types.GetRegionCardsCarouselByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetRegionCardsCarouselByIdQuery, Types.GetRegionCardsCarouselByIdQueryVariables>(GetRegionCardsCarouselByIdDocument, options);
        }
export type GetRegionCardsCarouselByIdQueryHookResult = ReturnType<typeof useGetRegionCardsCarouselByIdQuery>;
export type GetRegionCardsCarouselByIdLazyQueryHookResult = ReturnType<typeof useGetRegionCardsCarouselByIdLazyQuery>;
export type GetRegionCardsCarouselByIdSuspenseQueryHookResult = ReturnType<typeof useGetRegionCardsCarouselByIdSuspenseQuery>;
export type GetRegionCardsCarouselByIdQueryResult = Apollo.QueryResult<Types.GetRegionCardsCarouselByIdQuery, Types.GetRegionCardsCarouselByIdQueryVariables>;
export const GetStaticComponentByIdDocument = /*#__PURE__*/ gql`
    query getStaticComponentById($id: String!, $locale: String, $preview: Boolean) {
  swnz_componentStatic(id: $id, locale: $locale, preview: $preview) {
    ...staticComponent_SWNZ_ComponentStatic
  }
}
    ${StaticComponent_Swnz_ComponentStaticFragmentDoc}`;
export function useGetStaticComponentByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetStaticComponentByIdQuery, Types.GetStaticComponentByIdQueryVariables> & ({ variables: Types.GetStaticComponentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetStaticComponentByIdQuery, Types.GetStaticComponentByIdQueryVariables>(GetStaticComponentByIdDocument, options);
      }
export function useGetStaticComponentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetStaticComponentByIdQuery, Types.GetStaticComponentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetStaticComponentByIdQuery, Types.GetStaticComponentByIdQueryVariables>(GetStaticComponentByIdDocument, options);
        }
export function useGetStaticComponentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetStaticComponentByIdQuery, Types.GetStaticComponentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetStaticComponentByIdQuery, Types.GetStaticComponentByIdQueryVariables>(GetStaticComponentByIdDocument, options);
        }
export type GetStaticComponentByIdQueryHookResult = ReturnType<typeof useGetStaticComponentByIdQuery>;
export type GetStaticComponentByIdLazyQueryHookResult = ReturnType<typeof useGetStaticComponentByIdLazyQuery>;
export type GetStaticComponentByIdSuspenseQueryHookResult = ReturnType<typeof useGetStaticComponentByIdSuspenseQuery>;
export type GetStaticComponentByIdQueryResult = Apollo.QueryResult<Types.GetStaticComponentByIdQuery, Types.GetStaticComponentByIdQueryVariables>;
export const GetStatisticsByIdDocument = /*#__PURE__*/ gql`
    query getStatisticsById($id: String!, $locale: String, $preview: Boolean) {
  swnz_statContainer(id: $id, locale: $locale, preview: $preview) {
    ...statistics_SWNZ_StatContainer
  }
}
    ${Statistics_Swnz_StatContainerFragmentDoc}`;
export function useGetStatisticsByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetStatisticsByIdQuery, Types.GetStatisticsByIdQueryVariables> & ({ variables: Types.GetStatisticsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetStatisticsByIdQuery, Types.GetStatisticsByIdQueryVariables>(GetStatisticsByIdDocument, options);
      }
export function useGetStatisticsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetStatisticsByIdQuery, Types.GetStatisticsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetStatisticsByIdQuery, Types.GetStatisticsByIdQueryVariables>(GetStatisticsByIdDocument, options);
        }
export function useGetStatisticsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetStatisticsByIdQuery, Types.GetStatisticsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetStatisticsByIdQuery, Types.GetStatisticsByIdQueryVariables>(GetStatisticsByIdDocument, options);
        }
export type GetStatisticsByIdQueryHookResult = ReturnType<typeof useGetStatisticsByIdQuery>;
export type GetStatisticsByIdLazyQueryHookResult = ReturnType<typeof useGetStatisticsByIdLazyQuery>;
export type GetStatisticsByIdSuspenseQueryHookResult = ReturnType<typeof useGetStatisticsByIdSuspenseQuery>;
export type GetStatisticsByIdQueryResult = Apollo.QueryResult<Types.GetStatisticsByIdQuery, Types.GetStatisticsByIdQueryVariables>;
export const GetStatsImageCarouselByIdDocument = /*#__PURE__*/ gql`
    query getStatsImageCarouselById($id: String!, $locale: String, $preview: Boolean) {
  swnz_statsImageCarousel(id: $id, locale: $locale, preview: $preview) {
    ...statsImageCarousel_SWNZ_StatsImageCarousel
  }
}
    ${StatsImageCarousel_Swnz_StatsImageCarouselFragmentDoc}`;
export function useGetStatsImageCarouselByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetStatsImageCarouselByIdQuery, Types.GetStatsImageCarouselByIdQueryVariables> & ({ variables: Types.GetStatsImageCarouselByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetStatsImageCarouselByIdQuery, Types.GetStatsImageCarouselByIdQueryVariables>(GetStatsImageCarouselByIdDocument, options);
      }
export function useGetStatsImageCarouselByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetStatsImageCarouselByIdQuery, Types.GetStatsImageCarouselByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetStatsImageCarouselByIdQuery, Types.GetStatsImageCarouselByIdQueryVariables>(GetStatsImageCarouselByIdDocument, options);
        }
export function useGetStatsImageCarouselByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetStatsImageCarouselByIdQuery, Types.GetStatsImageCarouselByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetStatsImageCarouselByIdQuery, Types.GetStatsImageCarouselByIdQueryVariables>(GetStatsImageCarouselByIdDocument, options);
        }
export type GetStatsImageCarouselByIdQueryHookResult = ReturnType<typeof useGetStatsImageCarouselByIdQuery>;
export type GetStatsImageCarouselByIdLazyQueryHookResult = ReturnType<typeof useGetStatsImageCarouselByIdLazyQuery>;
export type GetStatsImageCarouselByIdSuspenseQueryHookResult = ReturnType<typeof useGetStatsImageCarouselByIdSuspenseQuery>;
export type GetStatsImageCarouselByIdQueryResult = Apollo.QueryResult<Types.GetStatsImageCarouselByIdQuery, Types.GetStatsImageCarouselByIdQueryVariables>;
export const GetStoryCardContainerByIdDocument = /*#__PURE__*/ gql`
    query getStoryCardContainerById($id: String!, $locale: String, $preview: Boolean) {
  swnz_storyCardContainer(id: $id, locale: $locale, preview: $preview) {
    ...storyCardContainer_SWNZ_StoryCardContainer
  }
}
    ${StoryCardContainer_Swnz_StoryCardContainerFragmentDoc}`;
export function useGetStoryCardContainerByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetStoryCardContainerByIdQuery, Types.GetStoryCardContainerByIdQueryVariables> & ({ variables: Types.GetStoryCardContainerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetStoryCardContainerByIdQuery, Types.GetStoryCardContainerByIdQueryVariables>(GetStoryCardContainerByIdDocument, options);
      }
export function useGetStoryCardContainerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetStoryCardContainerByIdQuery, Types.GetStoryCardContainerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetStoryCardContainerByIdQuery, Types.GetStoryCardContainerByIdQueryVariables>(GetStoryCardContainerByIdDocument, options);
        }
export function useGetStoryCardContainerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetStoryCardContainerByIdQuery, Types.GetStoryCardContainerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetStoryCardContainerByIdQuery, Types.GetStoryCardContainerByIdQueryVariables>(GetStoryCardContainerByIdDocument, options);
        }
export type GetStoryCardContainerByIdQueryHookResult = ReturnType<typeof useGetStoryCardContainerByIdQuery>;
export type GetStoryCardContainerByIdLazyQueryHookResult = ReturnType<typeof useGetStoryCardContainerByIdLazyQuery>;
export type GetStoryCardContainerByIdSuspenseQueryHookResult = ReturnType<typeof useGetStoryCardContainerByIdSuspenseQuery>;
export type GetStoryCardContainerByIdQueryResult = Apollo.QueryResult<Types.GetStoryCardContainerByIdQuery, Types.GetStoryCardContainerByIdQueryVariables>;
export const GetTilesByIdDocument = /*#__PURE__*/ gql`
    query getTilesById($id: String!, $locale: String, $preview: Boolean) {
  swnz_tileContainer(id: $id, locale: $locale, preview: $preview) {
    ...tileContainer_SWNZ_TileContainer
  }
}
    ${TileContainer_Swnz_TileContainerFragmentDoc}`;
export function useGetTilesByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetTilesByIdQuery, Types.GetTilesByIdQueryVariables> & ({ variables: Types.GetTilesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTilesByIdQuery, Types.GetTilesByIdQueryVariables>(GetTilesByIdDocument, options);
      }
export function useGetTilesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTilesByIdQuery, Types.GetTilesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTilesByIdQuery, Types.GetTilesByIdQueryVariables>(GetTilesByIdDocument, options);
        }
export function useGetTilesByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetTilesByIdQuery, Types.GetTilesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTilesByIdQuery, Types.GetTilesByIdQueryVariables>(GetTilesByIdDocument, options);
        }
export type GetTilesByIdQueryHookResult = ReturnType<typeof useGetTilesByIdQuery>;
export type GetTilesByIdLazyQueryHookResult = ReturnType<typeof useGetTilesByIdLazyQuery>;
export type GetTilesByIdSuspenseQueryHookResult = ReturnType<typeof useGetTilesByIdSuspenseQuery>;
export type GetTilesByIdQueryResult = Apollo.QueryResult<Types.GetTilesByIdQuery, Types.GetTilesByIdQueryVariables>;
export const GetValueComponentByIdDocument = /*#__PURE__*/ gql`
    query getValueComponentById($id: String!, $locale: String, $preview: Boolean) {
  swnz_value(id: $id, locale: $locale, preview: $preview) {
    ...value_SWNZ_Value
  }
}
    ${Value_Swnz_ValueFragmentDoc}`;
export function useGetValueComponentByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetValueComponentByIdQuery, Types.GetValueComponentByIdQueryVariables> & ({ variables: Types.GetValueComponentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetValueComponentByIdQuery, Types.GetValueComponentByIdQueryVariables>(GetValueComponentByIdDocument, options);
      }
export function useGetValueComponentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetValueComponentByIdQuery, Types.GetValueComponentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetValueComponentByIdQuery, Types.GetValueComponentByIdQueryVariables>(GetValueComponentByIdDocument, options);
        }
export function useGetValueComponentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetValueComponentByIdQuery, Types.GetValueComponentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetValueComponentByIdQuery, Types.GetValueComponentByIdQueryVariables>(GetValueComponentByIdDocument, options);
        }
export type GetValueComponentByIdQueryHookResult = ReturnType<typeof useGetValueComponentByIdQuery>;
export type GetValueComponentByIdLazyQueryHookResult = ReturnType<typeof useGetValueComponentByIdLazyQuery>;
export type GetValueComponentByIdSuspenseQueryHookResult = ReturnType<typeof useGetValueComponentByIdSuspenseQuery>;
export type GetValueComponentByIdQueryResult = Apollo.QueryResult<Types.GetValueComponentByIdQuery, Types.GetValueComponentByIdQueryVariables>;
export const GetCourseDetailPageByIdDocument = /*#__PURE__*/ gql`
    query getCourseDetailPageById($courseId: String!, $preview: Boolean!) {
  courseDetail: inventory(key: "courses", id: $courseId) {
    ...courseDetail_inventoryCourse
  }
  disclaimer: swnz_globalSettingsCollection(
    where: {codeId: "disclaimer-text-inventory"}
    preview: $preview
  ) {
    ...disclaimer_SWNZ_GlobalSettingsCollection
  }
  detailBanner: swnz_globalSettingsCollection(
    where: {codeId: "disclaimer-text-studying-in-nz"}
    preview: $preview
  ) {
    ...studyInNzDetailBanner_SWNZ_GlobalSettingsCollection
  }
}
    ${CourseDetail_InventoryCourseFragmentDoc}
${Disclaimer_Swnz_GlobalSettingsCollectionFragmentDoc}
${StudyInNzDetailBanner_Swnz_GlobalSettingsCollectionFragmentDoc}`;
export function useGetCourseDetailPageByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetCourseDetailPageByIdQuery, Types.GetCourseDetailPageByIdQueryVariables> & ({ variables: Types.GetCourseDetailPageByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetCourseDetailPageByIdQuery, Types.GetCourseDetailPageByIdQueryVariables>(GetCourseDetailPageByIdDocument, options);
      }
export function useGetCourseDetailPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetCourseDetailPageByIdQuery, Types.GetCourseDetailPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetCourseDetailPageByIdQuery, Types.GetCourseDetailPageByIdQueryVariables>(GetCourseDetailPageByIdDocument, options);
        }
export function useGetCourseDetailPageByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetCourseDetailPageByIdQuery, Types.GetCourseDetailPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetCourseDetailPageByIdQuery, Types.GetCourseDetailPageByIdQueryVariables>(GetCourseDetailPageByIdDocument, options);
        }
export type GetCourseDetailPageByIdQueryHookResult = ReturnType<typeof useGetCourseDetailPageByIdQuery>;
export type GetCourseDetailPageByIdLazyQueryHookResult = ReturnType<typeof useGetCourseDetailPageByIdLazyQuery>;
export type GetCourseDetailPageByIdSuspenseQueryHookResult = ReturnType<typeof useGetCourseDetailPageByIdSuspenseQuery>;
export type GetCourseDetailPageByIdQueryResult = Apollo.QueryResult<Types.GetCourseDetailPageByIdQuery, Types.GetCourseDetailPageByIdQueryVariables>;
export const GetProviderDetailPageByIdDocument = /*#__PURE__*/ gql`
    query getProviderDetailPageById($providerId: String!, $preview: Boolean!) {
  providerDetail: inventory(key: "providers", id: $providerId) {
    ...providerDetail_inventoryProvider
  }
  disclaimer: swnz_globalSettingsCollection(
    where: {codeId: "disclaimer-text-inventory"}
    preview: $preview
  ) {
    ...disclaimer_SWNZ_GlobalSettingsCollection
  }
}
    ${ProviderDetail_InventoryProviderFragmentDoc}
${Disclaimer_Swnz_GlobalSettingsCollectionFragmentDoc}`;
export function useGetProviderDetailPageByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetProviderDetailPageByIdQuery, Types.GetProviderDetailPageByIdQueryVariables> & ({ variables: Types.GetProviderDetailPageByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetProviderDetailPageByIdQuery, Types.GetProviderDetailPageByIdQueryVariables>(GetProviderDetailPageByIdDocument, options);
      }
export function useGetProviderDetailPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetProviderDetailPageByIdQuery, Types.GetProviderDetailPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetProviderDetailPageByIdQuery, Types.GetProviderDetailPageByIdQueryVariables>(GetProviderDetailPageByIdDocument, options);
        }
export function useGetProviderDetailPageByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetProviderDetailPageByIdQuery, Types.GetProviderDetailPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetProviderDetailPageByIdQuery, Types.GetProviderDetailPageByIdQueryVariables>(GetProviderDetailPageByIdDocument, options);
        }
export type GetProviderDetailPageByIdQueryHookResult = ReturnType<typeof useGetProviderDetailPageByIdQuery>;
export type GetProviderDetailPageByIdLazyQueryHookResult = ReturnType<typeof useGetProviderDetailPageByIdLazyQuery>;
export type GetProviderDetailPageByIdSuspenseQueryHookResult = ReturnType<typeof useGetProviderDetailPageByIdSuspenseQuery>;
export type GetProviderDetailPageByIdQueryResult = Apollo.QueryResult<Types.GetProviderDetailPageByIdQuery, Types.GetProviderDetailPageByIdQueryVariables>;
export const GetScholarshipDetailPageByIdDocument = /*#__PURE__*/ gql`
    query getScholarshipDetailPageById($scholarshipId: String!, $preview: Boolean!) {
  scholarshipDetail: inventory(key: "scholarships", id: $scholarshipId) {
    ...scholarshipDetail_inventoryScholarship
  }
  disclaimer: swnz_globalSettingsCollection(
    where: {codeId: "disclaimer-text-inventory"}
    preview: $preview
  ) {
    ...disclaimer_SWNZ_GlobalSettingsCollection
  }
}
    ${ScholarshipDetail_InventoryScholarshipFragmentDoc}
${Disclaimer_Swnz_GlobalSettingsCollectionFragmentDoc}`;
export function useGetScholarshipDetailPageByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetScholarshipDetailPageByIdQuery, Types.GetScholarshipDetailPageByIdQueryVariables> & ({ variables: Types.GetScholarshipDetailPageByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetScholarshipDetailPageByIdQuery, Types.GetScholarshipDetailPageByIdQueryVariables>(GetScholarshipDetailPageByIdDocument, options);
      }
export function useGetScholarshipDetailPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetScholarshipDetailPageByIdQuery, Types.GetScholarshipDetailPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetScholarshipDetailPageByIdQuery, Types.GetScholarshipDetailPageByIdQueryVariables>(GetScholarshipDetailPageByIdDocument, options);
        }
export function useGetScholarshipDetailPageByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetScholarshipDetailPageByIdQuery, Types.GetScholarshipDetailPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetScholarshipDetailPageByIdQuery, Types.GetScholarshipDetailPageByIdQueryVariables>(GetScholarshipDetailPageByIdDocument, options);
        }
export type GetScholarshipDetailPageByIdQueryHookResult = ReturnType<typeof useGetScholarshipDetailPageByIdQuery>;
export type GetScholarshipDetailPageByIdLazyQueryHookResult = ReturnType<typeof useGetScholarshipDetailPageByIdLazyQuery>;
export type GetScholarshipDetailPageByIdSuspenseQueryHookResult = ReturnType<typeof useGetScholarshipDetailPageByIdSuspenseQuery>;
export type GetScholarshipDetailPageByIdQueryResult = Apollo.QueryResult<Types.GetScholarshipDetailPageByIdQuery, Types.GetScholarshipDetailPageByIdQueryVariables>;
export const GetAlertBannersDocument = /*#__PURE__*/ gql`
    query getAlertBanners($locale: String!, $preview: Boolean, $id: String!) {
  globalBanner: swnz_alertBannerCollection(
    preview: $preview
    locale: $locale
    where: {codeId: "global-banner"}
  ) {
    items {
      ...entryId_SWNZ_Entry
      identifier
      title
      description {
        json
      }
      backgroundColour
      displayIcon
      codeId
    }
  }
  pageBanner: swnz_alertBanner(preview: $preview, locale: $locale, id: $id) {
    ...entryId_SWNZ_Entry
    identifier
    title
    description {
      json
    }
    backgroundColour
    displayIcon
    suppressGlobalAlertBanner
    codeId
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}`;
export function useGetAlertBannersQuery(baseOptions: Apollo.QueryHookOptions<Types.GetAlertBannersQuery, Types.GetAlertBannersQueryVariables> & ({ variables: Types.GetAlertBannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAlertBannersQuery, Types.GetAlertBannersQueryVariables>(GetAlertBannersDocument, options);
      }
export function useGetAlertBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAlertBannersQuery, Types.GetAlertBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAlertBannersQuery, Types.GetAlertBannersQueryVariables>(GetAlertBannersDocument, options);
        }
export function useGetAlertBannersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAlertBannersQuery, Types.GetAlertBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAlertBannersQuery, Types.GetAlertBannersQueryVariables>(GetAlertBannersDocument, options);
        }
export type GetAlertBannersQueryHookResult = ReturnType<typeof useGetAlertBannersQuery>;
export type GetAlertBannersLazyQueryHookResult = ReturnType<typeof useGetAlertBannersLazyQuery>;
export type GetAlertBannersSuspenseQueryHookResult = ReturnType<typeof useGetAlertBannersSuspenseQuery>;
export type GetAlertBannersQueryResult = Apollo.QueryResult<Types.GetAlertBannersQuery, Types.GetAlertBannersQueryVariables>;
export const GetAllNaumaiStandardPageSlugsForCatchAllRouteDocument = /*#__PURE__*/ gql`
    query getAllNaumaiStandardPageSlugsForCatchAllRoute {
  swnz_naumaiPageStandardCollection(
    where: {slug_not_in: ["sitemap", "naumai-homepage", "/", "search"]}
  ) {
    items {
      ...naumaiStandardPageSlugs_SWNZ_NaumaiPageStandard
    }
  }
}
    ${NaumaiStandardPageSlugs_Swnz_NaumaiPageStandardFragmentDoc}`;
export function useGetAllNaumaiStandardPageSlugsForCatchAllRouteQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQuery, Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQuery, Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryVariables>(GetAllNaumaiStandardPageSlugsForCatchAllRouteDocument, options);
      }
export function useGetAllNaumaiStandardPageSlugsForCatchAllRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQuery, Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQuery, Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryVariables>(GetAllNaumaiStandardPageSlugsForCatchAllRouteDocument, options);
        }
export function useGetAllNaumaiStandardPageSlugsForCatchAllRouteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQuery, Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQuery, Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryVariables>(GetAllNaumaiStandardPageSlugsForCatchAllRouteDocument, options);
        }
export type GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryHookResult = ReturnType<typeof useGetAllNaumaiStandardPageSlugsForCatchAllRouteQuery>;
export type GetAllNaumaiStandardPageSlugsForCatchAllRouteLazyQueryHookResult = ReturnType<typeof useGetAllNaumaiStandardPageSlugsForCatchAllRouteLazyQuery>;
export type GetAllNaumaiStandardPageSlugsForCatchAllRouteSuspenseQueryHookResult = ReturnType<typeof useGetAllNaumaiStandardPageSlugsForCatchAllRouteSuspenseQuery>;
export type GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryResult = Apollo.QueryResult<Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQuery, Types.GetAllNaumaiStandardPageSlugsForCatchAllRouteQueryVariables>;
export const GetAllNavigationElementsDocument = /*#__PURE__*/ gql`
    query getAllNavigationElements($preview: Boolean, $locale: String) {
  swnz_navigationElementCollection(preview: $preview, locale: $locale) {
    items {
      ...navigationElement_SWNZ_NavigationElement
    }
  }
}
    ${NavigationElement_Swnz_NavigationElementFragmentDoc}`;
export function useGetAllNavigationElementsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllNavigationElementsQuery, Types.GetAllNavigationElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllNavigationElementsQuery, Types.GetAllNavigationElementsQueryVariables>(GetAllNavigationElementsDocument, options);
      }
export function useGetAllNavigationElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllNavigationElementsQuery, Types.GetAllNavigationElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllNavigationElementsQuery, Types.GetAllNavigationElementsQueryVariables>(GetAllNavigationElementsDocument, options);
        }
export function useGetAllNavigationElementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllNavigationElementsQuery, Types.GetAllNavigationElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllNavigationElementsQuery, Types.GetAllNavigationElementsQueryVariables>(GetAllNavigationElementsDocument, options);
        }
export type GetAllNavigationElementsQueryHookResult = ReturnType<typeof useGetAllNavigationElementsQuery>;
export type GetAllNavigationElementsLazyQueryHookResult = ReturnType<typeof useGetAllNavigationElementsLazyQuery>;
export type GetAllNavigationElementsSuspenseQueryHookResult = ReturnType<typeof useGetAllNavigationElementsSuspenseQuery>;
export type GetAllNavigationElementsQueryResult = Apollo.QueryResult<Types.GetAllNavigationElementsQuery, Types.GetAllNavigationElementsQueryVariables>;
export const GetAllPageSlugsForCatchAllRouteDocument = /*#__PURE__*/ gql`
    query getAllPageSlugsForCatchAllRoute {
  swnz_pageCollection(
    where: {slug_not_in: ["search-results-course", "search-results-institution", "search-results-agent", "search-results-scholarship", "sitemap", "/", "search"]}
  ) {
    items {
      ...pageSlugs_SWNZ_Page
    }
  }
}
    ${PageSlugs_Swnz_PageFragmentDoc}`;
export function useGetAllPageSlugsForCatchAllRouteQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetAllPageSlugsForCatchAllRouteQuery, Types.GetAllPageSlugsForCatchAllRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetAllPageSlugsForCatchAllRouteQuery, Types.GetAllPageSlugsForCatchAllRouteQueryVariables>(GetAllPageSlugsForCatchAllRouteDocument, options);
      }
export function useGetAllPageSlugsForCatchAllRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetAllPageSlugsForCatchAllRouteQuery, Types.GetAllPageSlugsForCatchAllRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetAllPageSlugsForCatchAllRouteQuery, Types.GetAllPageSlugsForCatchAllRouteQueryVariables>(GetAllPageSlugsForCatchAllRouteDocument, options);
        }
export function useGetAllPageSlugsForCatchAllRouteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetAllPageSlugsForCatchAllRouteQuery, Types.GetAllPageSlugsForCatchAllRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetAllPageSlugsForCatchAllRouteQuery, Types.GetAllPageSlugsForCatchAllRouteQueryVariables>(GetAllPageSlugsForCatchAllRouteDocument, options);
        }
export type GetAllPageSlugsForCatchAllRouteQueryHookResult = ReturnType<typeof useGetAllPageSlugsForCatchAllRouteQuery>;
export type GetAllPageSlugsForCatchAllRouteLazyQueryHookResult = ReturnType<typeof useGetAllPageSlugsForCatchAllRouteLazyQuery>;
export type GetAllPageSlugsForCatchAllRouteSuspenseQueryHookResult = ReturnType<typeof useGetAllPageSlugsForCatchAllRouteSuspenseQuery>;
export type GetAllPageSlugsForCatchAllRouteQueryResult = Apollo.QueryResult<Types.GetAllPageSlugsForCatchAllRouteQuery, Types.GetAllPageSlugsForCatchAllRouteQueryVariables>;
export const GetNaumaiNavigationElementsByCodeIdDocument = /*#__PURE__*/ gql`
    query getNaumaiNavigationElementsByCodeId($codeId: String, $preview: Boolean, $locale: String, $skip: Int) {
  swnz_navigationCollection(
    where: {codeId: $codeId}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      codeId
      navigationElementsCollection(limit: 2, skip: $skip) {
        ...navigationElements_SWNZ_NavigationNavigationElementsCollection
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${NavigationElements_Swnz_NavigationNavigationElementsCollectionFragmentDoc}`;
export function useGetNaumaiNavigationElementsByCodeIdQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetNaumaiNavigationElementsByCodeIdQuery, Types.GetNaumaiNavigationElementsByCodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNaumaiNavigationElementsByCodeIdQuery, Types.GetNaumaiNavigationElementsByCodeIdQueryVariables>(GetNaumaiNavigationElementsByCodeIdDocument, options);
      }
export function useGetNaumaiNavigationElementsByCodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNaumaiNavigationElementsByCodeIdQuery, Types.GetNaumaiNavigationElementsByCodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNaumaiNavigationElementsByCodeIdQuery, Types.GetNaumaiNavigationElementsByCodeIdQueryVariables>(GetNaumaiNavigationElementsByCodeIdDocument, options);
        }
export function useGetNaumaiNavigationElementsByCodeIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNaumaiNavigationElementsByCodeIdQuery, Types.GetNaumaiNavigationElementsByCodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNaumaiNavigationElementsByCodeIdQuery, Types.GetNaumaiNavigationElementsByCodeIdQueryVariables>(GetNaumaiNavigationElementsByCodeIdDocument, options);
        }
export type GetNaumaiNavigationElementsByCodeIdQueryHookResult = ReturnType<typeof useGetNaumaiNavigationElementsByCodeIdQuery>;
export type GetNaumaiNavigationElementsByCodeIdLazyQueryHookResult = ReturnType<typeof useGetNaumaiNavigationElementsByCodeIdLazyQuery>;
export type GetNaumaiNavigationElementsByCodeIdSuspenseQueryHookResult = ReturnType<typeof useGetNaumaiNavigationElementsByCodeIdSuspenseQuery>;
export type GetNaumaiNavigationElementsByCodeIdQueryResult = Apollo.QueryResult<Types.GetNaumaiNavigationElementsByCodeIdQuery, Types.GetNaumaiNavigationElementsByCodeIdQueryVariables>;
export const GetNaumaiPageCollectionBySlugDocument = /*#__PURE__*/ gql`
    query getNaumaiPageCollectionBySlug($where: SWNZ_NaumaiPageStandardFilter, $preview: Boolean, $locale: String) {
  swnz_naumaiPageStandardCollection(
    where: $where
    preview: $preview
    limit: 1
    locale: $locale
  ) {
    items {
      ...standardPageNaumai_SWNZ_NaumaiPageStandard
    }
  }
}
    ${StandardPageNaumai_Swnz_NaumaiPageStandardFragmentDoc}`;
export function useGetNaumaiPageCollectionBySlugQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetNaumaiPageCollectionBySlugQuery, Types.GetNaumaiPageCollectionBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNaumaiPageCollectionBySlugQuery, Types.GetNaumaiPageCollectionBySlugQueryVariables>(GetNaumaiPageCollectionBySlugDocument, options);
      }
export function useGetNaumaiPageCollectionBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNaumaiPageCollectionBySlugQuery, Types.GetNaumaiPageCollectionBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNaumaiPageCollectionBySlugQuery, Types.GetNaumaiPageCollectionBySlugQueryVariables>(GetNaumaiPageCollectionBySlugDocument, options);
        }
export function useGetNaumaiPageCollectionBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNaumaiPageCollectionBySlugQuery, Types.GetNaumaiPageCollectionBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNaumaiPageCollectionBySlugQuery, Types.GetNaumaiPageCollectionBySlugQueryVariables>(GetNaumaiPageCollectionBySlugDocument, options);
        }
export type GetNaumaiPageCollectionBySlugQueryHookResult = ReturnType<typeof useGetNaumaiPageCollectionBySlugQuery>;
export type GetNaumaiPageCollectionBySlugLazyQueryHookResult = ReturnType<typeof useGetNaumaiPageCollectionBySlugLazyQuery>;
export type GetNaumaiPageCollectionBySlugSuspenseQueryHookResult = ReturnType<typeof useGetNaumaiPageCollectionBySlugSuspenseQuery>;
export type GetNaumaiPageCollectionBySlugQueryResult = Apollo.QueryResult<Types.GetNaumaiPageCollectionBySlugQuery, Types.GetNaumaiPageCollectionBySlugQueryVariables>;
export const GetNaumaiPagesForSitemapDocument = /*#__PURE__*/ gql`
    query getNaumaiPagesForSitemap {
  swnz_naumaiPageStandardCollection {
    ...naumaiSitemapPages_SWNZ_NaumaiPageCollection
  }
}
    ${NaumaiSitemapPages_Swnz_NaumaiPageCollectionFragmentDoc}`;
export function useGetNaumaiPagesForSitemapQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetNaumaiPagesForSitemapQuery, Types.GetNaumaiPagesForSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNaumaiPagesForSitemapQuery, Types.GetNaumaiPagesForSitemapQueryVariables>(GetNaumaiPagesForSitemapDocument, options);
      }
export function useGetNaumaiPagesForSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNaumaiPagesForSitemapQuery, Types.GetNaumaiPagesForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNaumaiPagesForSitemapQuery, Types.GetNaumaiPagesForSitemapQueryVariables>(GetNaumaiPagesForSitemapDocument, options);
        }
export function useGetNaumaiPagesForSitemapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNaumaiPagesForSitemapQuery, Types.GetNaumaiPagesForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNaumaiPagesForSitemapQuery, Types.GetNaumaiPagesForSitemapQueryVariables>(GetNaumaiPagesForSitemapDocument, options);
        }
export type GetNaumaiPagesForSitemapQueryHookResult = ReturnType<typeof useGetNaumaiPagesForSitemapQuery>;
export type GetNaumaiPagesForSitemapLazyQueryHookResult = ReturnType<typeof useGetNaumaiPagesForSitemapLazyQuery>;
export type GetNaumaiPagesForSitemapSuspenseQueryHookResult = ReturnType<typeof useGetNaumaiPagesForSitemapSuspenseQuery>;
export type GetNaumaiPagesForSitemapQueryResult = Apollo.QueryResult<Types.GetNaumaiPagesForSitemapQuery, Types.GetNaumaiPagesForSitemapQueryVariables>;
export const GetNavigationElementsForBreadcrumbsDocument = /*#__PURE__*/ gql`
    query getNavigationElementsForBreadcrumbs($codeId: String, $preview: Boolean, $locale: String) {
  swnz_navigationElementCollection(
    where: {codeId: $codeId}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ... on SWNZ_NavigationElement {
        ...navigationElement_SWNZ_NavigationElement
        navigationElementsCollection(limit: 10) {
          items {
            ... on SWNZ_NavigationElement {
              ...navigationElement_SWNZ_NavigationElement
            }
          }
        }
      }
    }
  }
}
    ${NavigationElement_Swnz_NavigationElementFragmentDoc}`;
export function useGetNavigationElementsForBreadcrumbsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetNavigationElementsForBreadcrumbsQuery, Types.GetNavigationElementsForBreadcrumbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNavigationElementsForBreadcrumbsQuery, Types.GetNavigationElementsForBreadcrumbsQueryVariables>(GetNavigationElementsForBreadcrumbsDocument, options);
      }
export function useGetNavigationElementsForBreadcrumbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNavigationElementsForBreadcrumbsQuery, Types.GetNavigationElementsForBreadcrumbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNavigationElementsForBreadcrumbsQuery, Types.GetNavigationElementsForBreadcrumbsQueryVariables>(GetNavigationElementsForBreadcrumbsDocument, options);
        }
export function useGetNavigationElementsForBreadcrumbsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNavigationElementsForBreadcrumbsQuery, Types.GetNavigationElementsForBreadcrumbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNavigationElementsForBreadcrumbsQuery, Types.GetNavigationElementsForBreadcrumbsQueryVariables>(GetNavigationElementsForBreadcrumbsDocument, options);
        }
export type GetNavigationElementsForBreadcrumbsQueryHookResult = ReturnType<typeof useGetNavigationElementsForBreadcrumbsQuery>;
export type GetNavigationElementsForBreadcrumbsLazyQueryHookResult = ReturnType<typeof useGetNavigationElementsForBreadcrumbsLazyQuery>;
export type GetNavigationElementsForBreadcrumbsSuspenseQueryHookResult = ReturnType<typeof useGetNavigationElementsForBreadcrumbsSuspenseQuery>;
export type GetNavigationElementsForBreadcrumbsQueryResult = Apollo.QueryResult<Types.GetNavigationElementsForBreadcrumbsQuery, Types.GetNavigationElementsForBreadcrumbsQueryVariables>;
export const GetNavigationElementsForFooterDocument = /*#__PURE__*/ gql`
    query getNavigationElementsForFooter($preview: Boolean, $locale: String) {
  footer: swnz_navigationCollection(
    where: {codeId: "footer"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      navigationElementsCollection(limit: 3) {
        items {
          ... on SWNZ_NavigationElement {
            ...navigationElement_SWNZ_NavigationElement
            navigationElementsCollection(limit: 8) {
              items {
                ... on SWNZ_NavigationElement {
                  ...navigationElement_SWNZ_NavigationElement
                }
              }
            }
          }
        }
      }
    }
  }
  socialLinks: swnz_navigationCollection(
    where: {codeId: "social-links"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      navigationElementsCollection(limit: 1) {
        items {
          ... on SWNZ_NavigationElement {
            ...navigationElement_SWNZ_NavigationElement
            navigationElementsCollection(limit: 8) {
              items {
                ... on SWNZ_NavigationElement {
                  ...navigationElement_SWNZ_NavigationElement
                }
              }
            }
          }
        }
      }
    }
  }
  legal: swnz_navigationCollection(
    where: {codeId: "legal"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      navigationElementsCollection(limit: 3) {
        items {
          ... on SWNZ_NavigationElement {
            ...navigationElement_SWNZ_NavigationElement
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${NavigationElement_Swnz_NavigationElementFragmentDoc}`;
export function useGetNavigationElementsForFooterQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetNavigationElementsForFooterQuery, Types.GetNavigationElementsForFooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNavigationElementsForFooterQuery, Types.GetNavigationElementsForFooterQueryVariables>(GetNavigationElementsForFooterDocument, options);
      }
export function useGetNavigationElementsForFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNavigationElementsForFooterQuery, Types.GetNavigationElementsForFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNavigationElementsForFooterQuery, Types.GetNavigationElementsForFooterQueryVariables>(GetNavigationElementsForFooterDocument, options);
        }
export function useGetNavigationElementsForFooterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNavigationElementsForFooterQuery, Types.GetNavigationElementsForFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNavigationElementsForFooterQuery, Types.GetNavigationElementsForFooterQueryVariables>(GetNavigationElementsForFooterDocument, options);
        }
export type GetNavigationElementsForFooterQueryHookResult = ReturnType<typeof useGetNavigationElementsForFooterQuery>;
export type GetNavigationElementsForFooterLazyQueryHookResult = ReturnType<typeof useGetNavigationElementsForFooterLazyQuery>;
export type GetNavigationElementsForFooterSuspenseQueryHookResult = ReturnType<typeof useGetNavigationElementsForFooterSuspenseQuery>;
export type GetNavigationElementsForFooterQueryResult = Apollo.QueryResult<Types.GetNavigationElementsForFooterQuery, Types.GetNavigationElementsForFooterQueryVariables>;
export const GetNavigationElementsForNaumaiFooterDocument = /*#__PURE__*/ gql`
    query getNavigationElementsForNaumaiFooter($preview: Boolean, $locale: String) {
  footer: swnz_navigationCollection(
    where: {codeId: "naumai-footer"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      navigationElementsCollection(limit: 5) {
        items {
          ... on SWNZ_NavigationElement {
            ...navigationElement_SWNZ_NavigationElement
            navigationElementsCollection(limit: 5) {
              items {
                ... on SWNZ_NavigationElement {
                  ...navigationElement_SWNZ_NavigationElement
                }
              }
            }
          }
        }
      }
    }
  }
  socialLinks: swnz_navigationCollection(
    where: {codeId: "naumai-social-links"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      navigationElementsCollection(limit: 3) {
        items {
          ... on SWNZ_NavigationElement {
            ...navigationElement_SWNZ_NavigationElement
          }
        }
      }
    }
  }
  legal: swnz_navigationCollection(
    where: {codeId: "naumai-legal"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      navigationElementsCollection(limit: 3) {
        items {
          ... on SWNZ_NavigationElement {
            ...navigationElement_SWNZ_NavigationElement
          }
        }
      }
    }
  }
  cta: swnz_navigationCollection(
    where: {codeId: "naumai-footer-cta"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      navigationElementsCollection(limit: 1) {
        items {
          ... on SWNZ_NavigationElement {
            ...navigationElement_SWNZ_NavigationElement
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${NavigationElement_Swnz_NavigationElementFragmentDoc}`;
export function useGetNavigationElementsForNaumaiFooterQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetNavigationElementsForNaumaiFooterQuery, Types.GetNavigationElementsForNaumaiFooterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetNavigationElementsForNaumaiFooterQuery, Types.GetNavigationElementsForNaumaiFooterQueryVariables>(GetNavigationElementsForNaumaiFooterDocument, options);
      }
export function useGetNavigationElementsForNaumaiFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetNavigationElementsForNaumaiFooterQuery, Types.GetNavigationElementsForNaumaiFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetNavigationElementsForNaumaiFooterQuery, Types.GetNavigationElementsForNaumaiFooterQueryVariables>(GetNavigationElementsForNaumaiFooterDocument, options);
        }
export function useGetNavigationElementsForNaumaiFooterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetNavigationElementsForNaumaiFooterQuery, Types.GetNavigationElementsForNaumaiFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetNavigationElementsForNaumaiFooterQuery, Types.GetNavigationElementsForNaumaiFooterQueryVariables>(GetNavigationElementsForNaumaiFooterDocument, options);
        }
export type GetNavigationElementsForNaumaiFooterQueryHookResult = ReturnType<typeof useGetNavigationElementsForNaumaiFooterQuery>;
export type GetNavigationElementsForNaumaiFooterLazyQueryHookResult = ReturnType<typeof useGetNavigationElementsForNaumaiFooterLazyQuery>;
export type GetNavigationElementsForNaumaiFooterSuspenseQueryHookResult = ReturnType<typeof useGetNavigationElementsForNaumaiFooterSuspenseQuery>;
export type GetNavigationElementsForNaumaiFooterQueryResult = Apollo.QueryResult<Types.GetNavigationElementsForNaumaiFooterQuery, Types.GetNavigationElementsForNaumaiFooterQueryVariables>;
export const GetPageCollectionBySlugDocument = /*#__PURE__*/ gql`
    query getPageCollectionBySlug($where: SWNZ_PageFilter, $preview: Boolean, $locale: String, $disclaimerCodeId: String) {
  swnz_pageCollection(where: $where, preview: $preview, limit: 1, locale: $locale) {
    items {
      ...entryId_SWNZ_Entry
      codeId
      showLcf
      pageTheme
      title
      ...parentPagePath_SWNZ_Page
      seo {
        ...seo_SWNZ_Seo
      }
      alertBanner {
        ...entryId_SWNZ_Entry
      }
      content {
        ...entryId_SWNZ_Entry
        ... on SWNZ_PageStandard {
          ...standardPage_SWNZ_PageStandard
        }
        ... on SWNZ_PageModal {
          ...modalPage_SWNZ_PageModal
        }
        ... on SWNZ_PageSearchResults {
          ...searchResultsPage_SWNZ_PageSearchResults
        }
      }
    }
  }
  disclaimer: swnz_globalSettingsCollection(
    where: {codeId: $disclaimerCodeId}
    preview: $preview
    locale: $locale
  ) {
    ...disclaimer_SWNZ_GlobalSettingsCollection
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${Seo_Swnz_SeoFragmentDoc}
${StandardPage_Swnz_PageStandardFragmentDoc}
${ModalPage_Swnz_PageModalFragmentDoc}
${SearchResultsPage_Swnz_PageSearchResultsFragmentDoc}
${Disclaimer_Swnz_GlobalSettingsCollectionFragmentDoc}`;
export function useGetPageCollectionBySlugQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetPageCollectionBySlugQuery, Types.GetPageCollectionBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPageCollectionBySlugQuery, Types.GetPageCollectionBySlugQueryVariables>(GetPageCollectionBySlugDocument, options);
      }
export function useGetPageCollectionBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPageCollectionBySlugQuery, Types.GetPageCollectionBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPageCollectionBySlugQuery, Types.GetPageCollectionBySlugQueryVariables>(GetPageCollectionBySlugDocument, options);
        }
export function useGetPageCollectionBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPageCollectionBySlugQuery, Types.GetPageCollectionBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPageCollectionBySlugQuery, Types.GetPageCollectionBySlugQueryVariables>(GetPageCollectionBySlugDocument, options);
        }
export type GetPageCollectionBySlugQueryHookResult = ReturnType<typeof useGetPageCollectionBySlugQuery>;
export type GetPageCollectionBySlugLazyQueryHookResult = ReturnType<typeof useGetPageCollectionBySlugLazyQuery>;
export type GetPageCollectionBySlugSuspenseQueryHookResult = ReturnType<typeof useGetPageCollectionBySlugSuspenseQuery>;
export type GetPageCollectionBySlugQueryResult = Apollo.QueryResult<Types.GetPageCollectionBySlugQuery, Types.GetPageCollectionBySlugQueryVariables>;
export const GetPageModalByIdDocument = /*#__PURE__*/ gql`
    query getPageModalById($id: String!, $locale: String, $preview: Boolean) {
  swnz_pageModal(id: $id, locale: $locale, preview: $preview) {
    ...entryId_SWNZ_Entry
    __typename
    hero {
      ...mediaImage_SWNZ_MediaImage
      ...mediaVideo_SWNZ_MediaVideo
    }
    sectionsCollection(limit: 20) {
      items {
        ...entryId_SWNZ_Entry
        ... on SWNZ_MediaImage {
          ...mediaImage_SWNZ_MediaImage
        }
        ... on SWNZ_MediaVideo {
          ...mediaVideo_SWNZ_MediaVideo
        }
        ... on SWNZ_ImpactText {
          ...impactText_SWNZ_ImpactText
        }
        ... on SWNZ_BulletPointContainer {
          ...bulletPoints_SWNZ_BulletPointContainer
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${MediaImage_Swnz_MediaImageFragmentDoc}
${MediaVideo_Swnz_MediaVideoFragmentDoc}
${ImpactText_Swnz_ImpactTextFragmentDoc}
${BulletPoints_Swnz_BulletPointContainerFragmentDoc}`;
export function useGetPageModalByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPageModalByIdQuery, Types.GetPageModalByIdQueryVariables> & ({ variables: Types.GetPageModalByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPageModalByIdQuery, Types.GetPageModalByIdQueryVariables>(GetPageModalByIdDocument, options);
      }
export function useGetPageModalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPageModalByIdQuery, Types.GetPageModalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPageModalByIdQuery, Types.GetPageModalByIdQueryVariables>(GetPageModalByIdDocument, options);
        }
export function useGetPageModalByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPageModalByIdQuery, Types.GetPageModalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPageModalByIdQuery, Types.GetPageModalByIdQueryVariables>(GetPageModalByIdDocument, options);
        }
export type GetPageModalByIdQueryHookResult = ReturnType<typeof useGetPageModalByIdQuery>;
export type GetPageModalByIdLazyQueryHookResult = ReturnType<typeof useGetPageModalByIdLazyQuery>;
export type GetPageModalByIdSuspenseQueryHookResult = ReturnType<typeof useGetPageModalByIdSuspenseQuery>;
export type GetPageModalByIdQueryResult = Apollo.QueryResult<Types.GetPageModalByIdQuery, Types.GetPageModalByIdQueryVariables>;
export const GetPageModalByIdTwoDocument = /*#__PURE__*/ gql`
    query getPageModalByIdTwo($id: String!, $locale: String, $preview: Boolean) {
  swnz_pageModal(id: $id, locale: $locale, preview: $preview) {
    ...entryId_SWNZ_Entry
    __typename
    sectionsCollection(limit: 5) {
      items {
        ...entryId_SWNZ_Entry
        ... on SWNZ_GenericText {
          ...genericText_SWNZ_GenericText
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${GenericText_Swnz_GenericTextFragmentDoc}`;
export function useGetPageModalByIdTwoQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPageModalByIdTwoQuery, Types.GetPageModalByIdTwoQueryVariables> & ({ variables: Types.GetPageModalByIdTwoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPageModalByIdTwoQuery, Types.GetPageModalByIdTwoQueryVariables>(GetPageModalByIdTwoDocument, options);
      }
export function useGetPageModalByIdTwoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPageModalByIdTwoQuery, Types.GetPageModalByIdTwoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPageModalByIdTwoQuery, Types.GetPageModalByIdTwoQueryVariables>(GetPageModalByIdTwoDocument, options);
        }
export function useGetPageModalByIdTwoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPageModalByIdTwoQuery, Types.GetPageModalByIdTwoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPageModalByIdTwoQuery, Types.GetPageModalByIdTwoQueryVariables>(GetPageModalByIdTwoDocument, options);
        }
export type GetPageModalByIdTwoQueryHookResult = ReturnType<typeof useGetPageModalByIdTwoQuery>;
export type GetPageModalByIdTwoLazyQueryHookResult = ReturnType<typeof useGetPageModalByIdTwoLazyQuery>;
export type GetPageModalByIdTwoSuspenseQueryHookResult = ReturnType<typeof useGetPageModalByIdTwoSuspenseQuery>;
export type GetPageModalByIdTwoQueryResult = Apollo.QueryResult<Types.GetPageModalByIdTwoQuery, Types.GetPageModalByIdTwoQueryVariables>;
export const GetPagesForSitemapDocument = /*#__PURE__*/ gql`
    query getPagesForSitemap($where: SWNZ_PageFilter, $locale: String, $preview: Boolean) {
  swnz_pageCollection(where: $where, locale: $locale, preview: $preview) {
    ...sitemapPages_SWNZ_PageCollection
  }
}
    ${SitemapPages_Swnz_PageCollectionFragmentDoc}`;
export function useGetPagesForSitemapQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetPagesForSitemapQuery, Types.GetPagesForSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPagesForSitemapQuery, Types.GetPagesForSitemapQueryVariables>(GetPagesForSitemapDocument, options);
      }
export function useGetPagesForSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPagesForSitemapQuery, Types.GetPagesForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPagesForSitemapQuery, Types.GetPagesForSitemapQueryVariables>(GetPagesForSitemapDocument, options);
        }
export function useGetPagesForSitemapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetPagesForSitemapQuery, Types.GetPagesForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetPagesForSitemapQuery, Types.GetPagesForSitemapQueryVariables>(GetPagesForSitemapDocument, options);
        }
export type GetPagesForSitemapQueryHookResult = ReturnType<typeof useGetPagesForSitemapQuery>;
export type GetPagesForSitemapLazyQueryHookResult = ReturnType<typeof useGetPagesForSitemapLazyQuery>;
export type GetPagesForSitemapSuspenseQueryHookResult = ReturnType<typeof useGetPagesForSitemapSuspenseQuery>;
export type GetPagesForSitemapQueryResult = Apollo.QueryResult<Types.GetPagesForSitemapQuery, Types.GetPagesForSitemapQueryVariables>;
export const GetSiteSearchNavigationElementsByCodeIdDocument = /*#__PURE__*/ gql`
    query getSiteSearchNavigationElementsByCodeId($codeId: String, $preview: Boolean, $locale: String) {
  swnz_navigationCollection(
    where: {codeId: $codeId}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      codeId
      navigationElementsCollection(limit: 10) {
        items {
          ... on SWNZ_NavigationElement {
            ...entryId_SWNZ_Entry
            title
            codeId
            customUrl
            openLinkInNewWindow
            internalPageLink {
              ... on SWNZ_Page {
                ...parentPagePath_SWNZ_Page
              }
              ... on SWNZ_NaumaiPageStandard {
                ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
              }
            }
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}`;
export function useGetSiteSearchNavigationElementsByCodeIdQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSiteSearchNavigationElementsByCodeIdQuery, Types.GetSiteSearchNavigationElementsByCodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSiteSearchNavigationElementsByCodeIdQuery, Types.GetSiteSearchNavigationElementsByCodeIdQueryVariables>(GetSiteSearchNavigationElementsByCodeIdDocument, options);
      }
export function useGetSiteSearchNavigationElementsByCodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSiteSearchNavigationElementsByCodeIdQuery, Types.GetSiteSearchNavigationElementsByCodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSiteSearchNavigationElementsByCodeIdQuery, Types.GetSiteSearchNavigationElementsByCodeIdQueryVariables>(GetSiteSearchNavigationElementsByCodeIdDocument, options);
        }
export function useGetSiteSearchNavigationElementsByCodeIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSiteSearchNavigationElementsByCodeIdQuery, Types.GetSiteSearchNavigationElementsByCodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSiteSearchNavigationElementsByCodeIdQuery, Types.GetSiteSearchNavigationElementsByCodeIdQueryVariables>(GetSiteSearchNavigationElementsByCodeIdDocument, options);
        }
export type GetSiteSearchNavigationElementsByCodeIdQueryHookResult = ReturnType<typeof useGetSiteSearchNavigationElementsByCodeIdQuery>;
export type GetSiteSearchNavigationElementsByCodeIdLazyQueryHookResult = ReturnType<typeof useGetSiteSearchNavigationElementsByCodeIdLazyQuery>;
export type GetSiteSearchNavigationElementsByCodeIdSuspenseQueryHookResult = ReturnType<typeof useGetSiteSearchNavigationElementsByCodeIdSuspenseQuery>;
export type GetSiteSearchNavigationElementsByCodeIdQueryResult = Apollo.QueryResult<Types.GetSiteSearchNavigationElementsByCodeIdQuery, Types.GetSiteSearchNavigationElementsByCodeIdQueryVariables>;
export const GetStandardPageHeroBySlugDocument = /*#__PURE__*/ gql`
    query getStandardPageHeroBySlug($where: SWNZ_PageFilter, $preview: Boolean, $locale: String) {
  swnz_pageCollection(where: $where, preview: $preview, limit: 1, locale: $locale) {
    items {
      ...entryId_SWNZ_Entry
      content {
        ...entryId_SWNZ_Entry
        ... on SWNZ_PageStandard {
          ...entryId_SWNZ_Entry
          hero {
            ...entryId_SWNZ_Entry
            ... on SWNZ_Hero {
              ...hero_SWNZ_Hero
            }
            ... on SWNZ_HeroFeatured {
              ...heroFeatured_SWNZ_HeroFeatured
            }
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${Hero_Swnz_HeroFragmentDoc}
${HeroFeatured_Swnz_HeroFeaturedFragmentDoc}`;
export function useGetStandardPageHeroBySlugQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetStandardPageHeroBySlugQuery, Types.GetStandardPageHeroBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetStandardPageHeroBySlugQuery, Types.GetStandardPageHeroBySlugQueryVariables>(GetStandardPageHeroBySlugDocument, options);
      }
export function useGetStandardPageHeroBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetStandardPageHeroBySlugQuery, Types.GetStandardPageHeroBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetStandardPageHeroBySlugQuery, Types.GetStandardPageHeroBySlugQueryVariables>(GetStandardPageHeroBySlugDocument, options);
        }
export function useGetStandardPageHeroBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetStandardPageHeroBySlugQuery, Types.GetStandardPageHeroBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetStandardPageHeroBySlugQuery, Types.GetStandardPageHeroBySlugQueryVariables>(GetStandardPageHeroBySlugDocument, options);
        }
export type GetStandardPageHeroBySlugQueryHookResult = ReturnType<typeof useGetStandardPageHeroBySlugQuery>;
export type GetStandardPageHeroBySlugLazyQueryHookResult = ReturnType<typeof useGetStandardPageHeroBySlugLazyQuery>;
export type GetStandardPageHeroBySlugSuspenseQueryHookResult = ReturnType<typeof useGetStandardPageHeroBySlugSuspenseQuery>;
export type GetStandardPageHeroBySlugQueryResult = Apollo.QueryResult<Types.GetStandardPageHeroBySlugQuery, Types.GetStandardPageHeroBySlugQueryVariables>;
export const GetSwnzNavigationElementsByCodeIdDocument = /*#__PURE__*/ gql`
    query getSwnzNavigationElementsByCodeId($codeId: String, $preview: Boolean, $locale: String, $skip: Int) {
  swnz_navigationCollection(
    where: {codeId: $codeId}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      codeId
      navigationElementsCollection(limit: 1, skip: $skip) {
        ...swnzNavigationElements_SWNZ_NavigationNavigationElementsCollection
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${SwnzNavigationElements_Swnz_NavigationNavigationElementsCollectionFragmentDoc}`;
export function useGetSwnzNavigationElementsByCodeIdQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetSwnzNavigationElementsByCodeIdQuery, Types.GetSwnzNavigationElementsByCodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSwnzNavigationElementsByCodeIdQuery, Types.GetSwnzNavigationElementsByCodeIdQueryVariables>(GetSwnzNavigationElementsByCodeIdDocument, options);
      }
export function useGetSwnzNavigationElementsByCodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSwnzNavigationElementsByCodeIdQuery, Types.GetSwnzNavigationElementsByCodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSwnzNavigationElementsByCodeIdQuery, Types.GetSwnzNavigationElementsByCodeIdQueryVariables>(GetSwnzNavigationElementsByCodeIdDocument, options);
        }
export function useGetSwnzNavigationElementsByCodeIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetSwnzNavigationElementsByCodeIdQuery, Types.GetSwnzNavigationElementsByCodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetSwnzNavigationElementsByCodeIdQuery, Types.GetSwnzNavigationElementsByCodeIdQueryVariables>(GetSwnzNavigationElementsByCodeIdDocument, options);
        }
export type GetSwnzNavigationElementsByCodeIdQueryHookResult = ReturnType<typeof useGetSwnzNavigationElementsByCodeIdQuery>;
export type GetSwnzNavigationElementsByCodeIdLazyQueryHookResult = ReturnType<typeof useGetSwnzNavigationElementsByCodeIdLazyQuery>;
export type GetSwnzNavigationElementsByCodeIdSuspenseQueryHookResult = ReturnType<typeof useGetSwnzNavigationElementsByCodeIdSuspenseQuery>;
export type GetSwnzNavigationElementsByCodeIdQueryResult = Apollo.QueryResult<Types.GetSwnzNavigationElementsByCodeIdQuery, Types.GetSwnzNavigationElementsByCodeIdQueryVariables>;
export const GetTopNavigationElementsByCodeIdDocument = /*#__PURE__*/ gql`
    query getTopNavigationElementsByCodeId($codeId: String, $preview: Boolean, $locale: String) {
  swnz_navigationCollection(
    where: {codeId: $codeId}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      ...entryId_SWNZ_Entry
      codeId
      navigationElementsCollection(limit: 8) {
        items {
          ... on SWNZ_NavigationElement {
            ...entryId_SWNZ_Entry
            title
            codeId
            customUrl
            openLinkInNewWindow
            internalPageLink {
              ... on SWNZ_Page {
                ...parentPagePath_SWNZ_Page
              }
              ... on SWNZ_NaumaiPageStandard {
                ...parentNaumaiPagePath_SWNZ_NaumaiPageStandard
              }
            }
          }
        }
      }
    }
  }
}
    ${EntryId_Swnz_EntryFragmentDoc}
${ParentPagePath_Swnz_PageFragmentDoc}
${ParentNaumaiPagePath_Swnz_NaumaiPageStandardFragmentDoc}`;
export function useGetTopNavigationElementsByCodeIdQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetTopNavigationElementsByCodeIdQuery, Types.GetTopNavigationElementsByCodeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetTopNavigationElementsByCodeIdQuery, Types.GetTopNavigationElementsByCodeIdQueryVariables>(GetTopNavigationElementsByCodeIdDocument, options);
      }
export function useGetTopNavigationElementsByCodeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetTopNavigationElementsByCodeIdQuery, Types.GetTopNavigationElementsByCodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetTopNavigationElementsByCodeIdQuery, Types.GetTopNavigationElementsByCodeIdQueryVariables>(GetTopNavigationElementsByCodeIdDocument, options);
        }
export function useGetTopNavigationElementsByCodeIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Types.GetTopNavigationElementsByCodeIdQuery, Types.GetTopNavigationElementsByCodeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Types.GetTopNavigationElementsByCodeIdQuery, Types.GetTopNavigationElementsByCodeIdQueryVariables>(GetTopNavigationElementsByCodeIdDocument, options);
        }
export type GetTopNavigationElementsByCodeIdQueryHookResult = ReturnType<typeof useGetTopNavigationElementsByCodeIdQuery>;
export type GetTopNavigationElementsByCodeIdLazyQueryHookResult = ReturnType<typeof useGetTopNavigationElementsByCodeIdLazyQuery>;
export type GetTopNavigationElementsByCodeIdSuspenseQueryHookResult = ReturnType<typeof useGetTopNavigationElementsByCodeIdSuspenseQuery>;
export type GetTopNavigationElementsByCodeIdQueryResult = Apollo.QueryResult<Types.GetTopNavigationElementsByCodeIdQuery, Types.GetTopNavigationElementsByCodeIdQueryVariables>;